import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'SHOT BAND',
    loading: 'Loading SHOT BAND...',

    heroWelcome: 'Welcome to',
    heroMemberBadge: 'SHOT BAND member',
    heroDaysLeftOne: '{{count}} day left',
    heroDaysLeftFew: '{{count}} days left',
    heroDaysLeftMany: '{{count}} days left',
    heroDaysLeftZero: 'Membership ends today',
    heroRenewButton: 'Renew',
    heroOfferTitlePrefix: 'The',
    heroOfferTitleSuffix: 'top-up turns the club on — here or in any top-up.',
    heroOfferBody: 'Cashback up to 4% — it grows with your level — daily quests and a shot at the knife raffle.',
    heroOfferFinePrint: 'The whole amount lands on your game balance. Spend it on cases, contracts, games and upgrades however you like.',
    heroJoinButton: 'Join for',
    heroHowItWorks: 'How it works',

    rulesTitle: 'How SHOT BAND works',
    rule1Prefix: 'Top up ',
    rule1Suffix: " in one payment — you're in SHOT BAND for 28 days. The coins land on your balance as usual.",
    rule1Title: 'Joining SHOT BAND',
    rule2Title: 'Cashback up to 4%',
    rule2: 'Every coin game pays cashback back in sparks. The rate grows with your level — 1% at level 10, 4% at level 100. Claim it every 7 days.',
    rule3Title: 'Cases for sparks',
    rule3Prefix: 'Sparks ',
    rule3Suffix: ' open SHOT BAND cases — skins all the way up to knives.',
    rule4Title: 'Quests and streak',
    rule4Prefix: 'Daily quests earn ',
    rule4Mid: '. Keep a 7-day streak — get +10 ',
    rule4Suffix: ' as a bonus.',
    rule5Title: 'Weekly knife raffle',
    rule5Prefix: 'Every week we raffle a knife. Invest your ',
    rule5Suffix: ' — more tickets, higher chance.',
    rule6Title: 'Daily race',
    rule6: 'Wager the most coins before midnight (MSK) and take the day’s skin. Every day, a new prize.',
    rule7Title: 'Free cases for turnover',
    rule7: 'Your daily turnover opens shelf cases for free — the more you play, the richer the free case. Up to every case, every day.',

    ticketSheetTitleJoin: 'Join SHOT BAND',
    ticketSheetTitleRenew: 'Renew SHOT BAND',
    ticketSheetTopupNotePrefix: 'Your balance is credited with',
    ticketSheetTopupNoteSuffix: 'right away — the club comes as a gift.',
    ticketSheetRenewDisclaimer: 'Renewal adds 28 days to your current membership term.',
    ticketSheetRenewTooEarly: 'Renewal opens a day before your membership ends — come back closer to that date.',
    ticketSheetBuyButton: 'Pay',
    ticketSheetLoadingProviders: 'Loading payment methods...',
    ticketSheetNoProviders: 'No payment methods available right now.',
    ticketSheetErrorTitle: 'Could not create the invoice',
    ticketSheetErrorHint: 'Try again or pick another method',
    ticketSheetLoadErrorGeneric: 'Failed to load payment methods.',
    ticketSheetPriceUnavailable: 'Price unavailable for this payment method — try another one.',
    ticketSheetCardConfirmTitle: 'Confirm payment',
    ticketSheetCardConfirmMessage: 'Charge {{amount}} from {{card}} to join SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pay',
    ticketSheetCardPending: 'Click is still confirming the payment — your membership will switch on automatically.',
    ticketSheetCardErrorTitle: 'Payment did not go through',
    ticketSheetCardErrorHint: 'Try again; if the money left your card, contact support',

    cashbackBalanceLabel: 'Club balance',
    cashbackCoinsLabel: 'Sparks',
    cashbackTicketsLabel: 'Tickets',
    cashbackNextPayoutLabel: 'Next payout:',
    mechanicNameCase: 'Cases',
    mechanicNameBattle: 'Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roulette',
    mechanicNameUpgrade: 'Upgrades',
    mechanicNameContract: 'Contracts',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback from lvl {{level}}',
    cashbackSpendButton: 'Spend',
    cashbackInvestButton: 'Invest',
    cashbackFrozenNote: 'Your membership has ended — the sparks and tickets stay yours. You can still claim sparks; spending them and entering the raffle need the club back on.',
    cashbackUnlockButton: 'Come back',
    cashbackClaimReadyLabel: 'Cashback ready:',
    cashbackClaimButton: 'Claim',
    cashbackTimerLabel: 'in',

    streakDayLabel: 'Day {{day}} of 7',
    streakHint: '{{days}} days in a row — bonus',

    freeCasesTitle: 'Free case',
    freeCasesTurnoverLabel: 'Turnover today',
    freeCasesNextHintPrefix: 'Wager',
    freeCasesNextHintSuffix: "more and you'll open it for free",
    freeCasesReadyHint: 'Free to open — go!',
    freeCasesAllClaimed: 'All free opens for today are spent — new ones after the reset',
    freeCasesTimerBurnOpen: 'The free open burns at the reset',
    freeCasesTimerBurnProgress: 'Turnover progress burns at the reset',
    freeCasesTimerPlain: 'Day resets in',
    freeCasesTimerNew: 'New free opens in',
    freeCasesOpenFreeButton: 'Open',
    freeCasesRulesTitle: 'Free case rules',
    freeCasesRulesWagerTitle: 'Play for coins',
    freeCasesRulesWagerBody: 'Every coin game counts into your daily turnover — cases, battles, upgrades, contracts, Rush Mid, roulette.',
    freeCasesRulesOpenTitle: 'Reach the threshold — open for free',
    freeCasesRulesOpenBody: 'Each case has its own turnover threshold. Reached it — the club pays for the open. One free open per case per day.',
    freeCasesRulesResetTitle: 'Everything burns at midnight',
    freeCasesRulesResetBody: 'At midnight (MSK) the day resets: turnover progress and unclaimed free opens burn. Next day — from zero.',

    questsTitle: 'Daily quests',
    questsResetLabel: 'New quests in',
    questClaimButton: 'Claim',
    questsLockedJoinButton: 'Join',
    questGenericTitle: 'Daily quest',
    questCompletedToastOverline: 'Quest complete!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Open 3 cases worth',
    quest_open_3_cases_2500_suffix: 'or more',
    quest_open_3_cases_2500_unit: 'cases',
    quest_rush_3_matches_prefix: 'Play 3 Rush Mid matches',
    quest_rush_3_matches_unit: 'matches',
    quest_open_band_case_prefix: 'Open a SHOT BAND case',
    quest_open_band_case_unit: 'case',
    quest_wager_25k_prefix: 'Wager',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Play 2 case battles with an entry of',
    quest_battles_2_5k_suffix: 'or more',
    quest_battles_2_5k_unit: 'battles',
    quest_upgrades_3_2500_prefix: 'Make 3 upgrades worth',
    quest_upgrades_3_2500_suffix: 'or more',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Complete a contract worth',
    quest_contract_10k_suffix: 'or more',
    quest_contract_10k_unit: 'contract',
    quest_win_battle_prefix: 'Win a case battle',
    quest_win_battle_unit: 'battle',
    quest_win_upgrade_prefix: 'Win an upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Open a case worth',
    quest_open_case_12500_suffix: 'or more',
    quest_open_case_12500_unit: 'case',
    quest_open_5_cases_1000_prefix: 'Open 5 cases worth',
    quest_open_5_cases_1000_suffix: 'or more',
    quest_open_5_cases_1000_unit: 'cases',
    quest_roulette_play_prefix: 'Play a roulette round',
    quest_roulette_play_unit: 'round',
    quest_contracts_25k_sum_prefix: 'Complete contracts worth',
    quest_contracts_25k_sum_suffix: 'in total',
    quest_upgrades_15k_sum_prefix: 'Make upgrades worth',
    quest_upgrades_15k_sum_suffix: 'in total',
    quest_rush_5_matches_prefix: 'Play 5 Rush Mid matches',
    quest_rush_5_matches_unit: 'matches',
    quest_wager_50k_prefix: 'Wager',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Wager',
    quest_wager_10k_battles_suffix: 'in case battles',
    quest_wager_10k_rush_prefix: 'Wager',
    quest_wager_10k_rush_suffix: 'in Rush Mid',
    quest_wager_10k_roulette_prefix: 'Wager',
    quest_wager_10k_roulette_suffix: 'in roulette',
    quest_wager_100k_prefix: 'Wager',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Win a Rush Mid match',
    quest_rush_mid_win_unit: 'win',
    quest_big_drop_25k_prefix: 'Drop an item worth over',
    quest_big_drop_25k_suffix: 'from a case',
    quest_big_drop_25k_unit: 'item',
    quest_risky_upgrade_35_prefix: 'Win an upgrade with odds of 35% or lower',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Drop a Covert item from a case',
    quest_covert_drop_unit: 'item',

    raceTitle: 'Daily race',
    raceEmpty: 'No race today — check back later',
    rulesLinkLabel: 'Rules',
    raceRulesTitle: 'Daily race rules',
    raceRulesPlayTitle: 'How to win',
    raceRulesPlayBody: 'Play anything on SHOT — cases, upgrades, contracts, battles, Rush Mid, roulette. The coins you spend on games count: the biggest daily turnover wins.',
    raceRulesPrizeTitle: 'The prize',
    raceRulesPrizeBody: 'A new skin every day. At midnight (MSK) it goes to the #1 player and lands straight in their inventory.',
    raceRulesMembersTitle: 'Members only',
    raceRulesMembersBody: 'The race is for SHOT BAND members. Your play counts automatically — nothing to activate.',
    raffleRulesTitle: 'Weekly raffle rules',
    raffleRulesTicketsTitle: 'Earn tickets',
    raffleRulesTicketsBodyPrefix: 'Complete daily quests to earn raffle tickets',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'Invest to raise your chance',
    raffleRulesChanceBody: 'Invest tickets into the round — the more you invest, the higher your chance. Invested tickets are not returned, adding more is always allowed.',
    raffleRulesFinalTitle: 'The final',
    raffleRulesFinalBody: 'The round runs for a week. The winner is drawn at random and the skin lands straight in their inventory.',
    racePrizeLabel: "Today's prize",
    raceYourPlace: 'Your place',
    raceParticipantsLabel: 'Playing',
    raceNotWagered: 'Play anything today to join the race',

    raffleTitle: 'Weekly raffle',
    raffleEmpty: 'No raffle running this week',
    raffleMyInvestedLabel: 'Invested',
    raffleParticipantsLabel: 'Playing',
    raffleParticipantOne: 'participant',
    raffleParticipantFew: 'participants',
    raffleParticipantMany: 'participants',
    raffleInvestButton: 'Invest',
    raffleGoToQuestsButton: 'Go to quests',
    raffleEndedButton: 'Round ended',
    raffleWinnersLink: 'Winners',

    investSheetTitle: 'Invest in the raffle',
    investSheetLockedBody: 'Join SHOT BAND to invest in the weekly raffle.',
    investSheetJoinButton: 'Join',
    investSheetEndedBody: 'This round has ended — wait for the next one.',
    investSheetNoBalanceBody: 'Nothing to invest yet — complete daily quests to earn some.',
    investSheetDecrease: 'Decrease',
    investSheetIncrease: 'Increase',
    investSheetBalanceHint: '{{balance}} available',
    investSheetDisclaimer: 'Invested amounts are not returned — you can always add more.',
    investSheetErrorGeneric: 'Failed to invest. Try again.',
    investSheetSubmitButton: 'Invest',
  },
  ru: {
    title: 'SHOT BAND',
    loading: 'Загрузка SHOT BAND...',

    heroWelcome: 'Добро пожаловать в',
    heroMemberBadge: 'Ты в SHOT BAND',
    heroDaysLeftOne: 'Остался {{count}} день',
    heroDaysLeftFew: 'Осталось {{count}} дня',
    heroDaysLeftMany: 'Осталось {{count}} дней',
    heroDaysLeftZero: 'Членство заканчивается сегодня',
    heroRenewButton: 'Продлить',
    heroOfferTitlePrefix: 'Пополнение на',
    heroOfferTitleSuffix: 'включает клуб — здесь или в обычном пополнении.',
    heroOfferBody: 'Кешбэк до 4% — растёт с уровнем, ежедневные задания и шанс выиграть нож в розыгрыше.',
    heroOfferFinePrint: 'Вся сумма зачислится на твой игровой баланс. Ты сможешь тратить её на кейсы, контракты, игры и апгрейды как захочешь.',
    heroJoinButton: 'Вступить за',
    heroHowItWorks: 'Как это работает',

    rulesTitle: 'Как работает SHOT BAND',
    rule1Prefix: 'Закинь ',
    rule1Suffix: ' одним платежом — ты в SHOT BAND на 28 дней. Монеты придут на твой баланс, как обычно.',
    rule1Title: 'Вход в SHOT BAND',
    rule2Title: 'Кешбэк до 4%',
    rule2: 'Каждая игра за монеты возвращает кешбэк искрами. Процент растёт с уровнем — 1% на 10-м, 4% на 100-м. Забирай каждые 7 дней.',
    rule3Title: 'Кейсы за искры',
    rule3Prefix: 'Искры ',
    rule3Suffix: ' открывают кейсы SHOT BAND — внутри скины вплоть до ножей.',
    rule4Title: 'Задания и стрик',
    rule4Prefix: 'Ежедневные задания приносят ',
    rule4Mid: '. Держи стрик 7 дней — получишь +10 ',
    rule4Suffix: ' бонусом.',
    rule5Title: 'Розыгрыш ножа',
    rule5Prefix: 'Каждую неделю разыгрываем нож. Вкладывай ',
    rule5Suffix: ' — чем больше билетов, тем выше шанс.',
    rule6Title: 'Гонка дня',
    rule6: 'Наиграй за монеты больше всех до полуночи мск — и скин дня твой. Каждый день новый приз.',
    rule7Title: 'Кейсы бесплатно за оборот',
    rule7: 'Дневной оборот открывает кейсы полки бесплатно — чем больше играешь, тем дороже фри-кейс. Хоть все кейсы, хоть каждый день.',

    ticketSheetTitleJoin: 'Вступление в SHOT BAND',
    ticketSheetTitleRenew: 'Продление SHOT BAND',
    ticketSheetTopupNotePrefix: 'На баланс сразу зачислится',
    ticketSheetTopupNoteSuffix: '— клуб идёт подарком.',
    ticketSheetRenewDisclaimer: 'Продление добавится к текущему сроку членства — плюс 28 дней.',
    ticketSheetRenewTooEarly: 'Продление откроется за сутки до конца членства — загляни ближе к этому сроку.',
    ticketSheetBuyButton: 'Оплатить',
    ticketSheetLoadingProviders: 'Загружаем способы оплаты...',
    ticketSheetNoProviders: 'Сейчас нет доступных способов оплаты.',
    ticketSheetErrorTitle: 'Не получилось создать счёт',
    ticketSheetErrorHint: 'Попробуй ещё раз или выбери другой способ',
    ticketSheetLoadErrorGeneric: 'Не удалось загрузить способы оплаты.',
    ticketSheetPriceUnavailable: 'Цена недоступна для этого способа — выбери другой.',
    ticketSheetCardConfirmTitle: 'Подтверди оплату',
    ticketSheetCardConfirmMessage: 'Списать {{amount}} с карты {{card}} за пропуск в SHOT BAND?',
    ticketSheetCardConfirmOk: 'Оплатить',
    ticketSheetCardPending: 'Click ещё подтверждает платёж — членство включится автоматически.',
    ticketSheetCardErrorTitle: 'Оплата не прошла',
    ticketSheetCardErrorHint: 'Попробуй ещё раз; если деньги ушли с карты, напиши в поддержку',

    cashbackBalanceLabel: 'Баланс клуба',
    cashbackCoinsLabel: 'Искры',
    cashbackTicketsLabel: 'Билеты',
    cashbackNextPayoutLabel: 'Следующая выплата:',
    mechanicNameCase: 'Кейсы',
    mechanicNameBattle: 'Case Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Рулетка',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Контракты',
    cashbackChipPrefix: 'кешбэк',
    cashbackChipLocked: 'кешбэк с {{level}} уровня',
    cashbackSpendButton: 'Потратить',
    cashbackInvestButton: 'Вложить',
    cashbackFrozenNote: 'Членство закончилось — искры и билеты остались твоими. Забрать искры можно и сейчас, а тратить их и вкладывать билеты — только в клубе.',
    cashbackUnlockButton: 'Вернуться',
    cashbackClaimReadyLabel: 'Кешбэк готов:',
    cashbackClaimButton: 'Забрать',
    cashbackTimerLabel: 'через',

    streakDayLabel: 'День {{day}} из 7',
    streakHint: '{{days}} дней подряд — бонус',

    freeCasesTitle: 'Бесплатный кейс',
    freeCasesTurnoverLabel: 'Оборот сегодня',
    freeCasesNextHintPrefix: 'Ещё',
    freeCasesNextHintSuffix: 'оборота — и откроешь его бесплатно',
    freeCasesReadyHint: 'Можно открыть бесплатно — забирай!',
    freeCasesAllClaimed: 'Всё бесплатное на сегодня открыто — новые после сброса',
    freeCasesTimerBurnOpen: 'Не откроешь до сброса — сгорит',
    freeCasesTimerBurnProgress: 'Прогресс оборота сгорит через',
    freeCasesTimerPlain: 'До сброса дня',
    freeCasesTimerNew: 'Новые бесплатные открытия через',
    freeCasesOpenFreeButton: 'Открыть',
    freeCasesRulesTitle: 'Правила бесплатного кейса',
    freeCasesRulesWagerTitle: 'Играй за монеты',
    freeCasesRulesWagerBody: 'Любая игра за монеты идёт в дневной оборот — кейсы, битвы, апгрейды, контракты, Rush Mid, рулетка.',
    freeCasesRulesOpenTitle: 'Взял порог — открываешь бесплатно',
    freeCasesRulesOpenBody: 'У каждого кейса свой порог оборота. Добрался — клуб платит за открытие. Одно бесплатное открытие на кейс в день.',
    freeCasesRulesResetTitle: 'В полночь всё сгорает',
    freeCasesRulesResetBody: 'В полночь по Москве день обнуляется: прогресс оборота и невзятые бесплатные открытия сгорают. Новый день — с нуля.',

    questsTitle: 'Задания дня',
    questsResetLabel: 'Новые задания через',
    questClaimButton: 'Забрать',
    questsLockedJoinButton: 'Вступить',
    questGenericTitle: 'Ежедневное задание',
    questCompletedToastOverline: 'Задание выполнено!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Открой 3 кейса от',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'кейса',
    quest_rush_3_matches_prefix: 'Сыграй 3 матча в Rush Mid',
    quest_rush_3_matches_unit: 'матча',
    quest_open_band_case_prefix: 'Открой кейс SHOT BAND',
    quest_open_band_case_unit: 'кейс',
    quest_wager_25k_prefix: 'Прокрути',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Сыграй 2 баттла стоимостью от',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'баттла',
    quest_upgrades_3_2500_prefix: 'Сделай 3 апгрейда от',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'апгрейда',
    quest_contract_10k_prefix: 'Собери контракт от',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'контракт',
    quest_win_battle_prefix: 'Выиграй баттл',
    quest_win_battle_unit: 'баттл',
    quest_win_upgrade_prefix: 'Выиграй апгрейд',
    quest_win_upgrade_unit: 'апгрейд',
    quest_open_case_12500_prefix: 'Открой кейс от',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'кейс',
    quest_open_5_cases_1000_prefix: 'Открой 5 кейсов от',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'кейсов',
    quest_roulette_play_prefix: 'Сыграй раунд рулетки',
    quest_roulette_play_unit: 'раунд',
    quest_contracts_25k_sum_prefix: 'Собери контрактов на',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Сделай апгрейдов на',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Сыграй 5 матчей Rush Mid',
    quest_rush_5_matches_unit: 'матчей',
    quest_wager_50k_prefix: 'Прокрути',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Прокрути',
    quest_wager_10k_battles_suffix: 'в баттлах',
    quest_wager_10k_rush_prefix: 'Прокрути',
    quest_wager_10k_rush_suffix: 'в Rush Mid',
    quest_wager_10k_roulette_prefix: 'Прокрути',
    quest_wager_10k_roulette_suffix: 'в рулетке',
    quest_wager_100k_prefix: 'Прокрути',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Победи в Rush Mid',
    quest_rush_mid_win_unit: 'победа',
    quest_big_drop_25k_prefix: 'Выбей предмет дороже',
    quest_big_drop_25k_suffix: 'из кейса',
    quest_big_drop_25k_unit: 'предмет',
    quest_risky_upgrade_35_prefix: 'Выиграй апгрейд с шансом до 35%',
    quest_risky_upgrade_35_unit: 'апгрейд',
    quest_covert_drop_prefix: 'Выбей предмет Covert из кейса',
    quest_covert_drop_unit: 'предмет',

    raceTitle: 'Гонка дня',
    raceEmpty: 'Сегодня гонки нет — загляни позже',
    rulesLinkLabel: 'Правила',
    raceRulesTitle: 'Правила гонки дня',
    raceRulesPlayTitle: 'Как победить',
    raceRulesPlayBody: 'Играй во что угодно в SHOT — кейсы, апгрейды, контракты, баттлы, Rush Mid, рулетку. Считаются потраченные на игры монеты: у кого оборот за день больше всех — тот и победил.',
    raceRulesPrizeTitle: 'Приз',
    raceRulesPrizeBody: 'Каждый день — новый скин. В полночь по Москве он уходит первому месту и сразу падает в инвентарь.',
    raceRulesMembersTitle: 'Только для клуба',
    raceRulesMembersBody: 'Гонка — для членов SHOT BAND. Игра засчитывается автоматически, ничего включать не надо.',
    raffleRulesTitle: 'Правила розыгрыша недели',
    raffleRulesTicketsTitle: 'Получай билеты',
    raffleRulesTicketsBodyPrefix: 'Выполняй задания дня — за них дают билеты',
    raffleRulesTicketsBodySuffix: 'розыгрыша.',
    raffleRulesChanceTitle: 'Вкладывай и повышай шанс',
    raffleRulesChanceBody: 'Вкладывай билеты в раунд — чем больше вложил, тем выше шанс. Вложенное не возвращается, докидывать можно всегда.',
    raffleRulesFinalTitle: 'Финал',
    raffleRulesFinalBody: 'Раунд идёт неделю. Победителя выбирает случайность, скин сразу падает в инвентарь.',
    racePrizeLabel: 'Приз дня',
    raceYourPlace: 'Твоё место',
    raceParticipantsLabel: 'Участвует',
    raceNotWagered: 'Сыграй сегодня в любую игру — и ты в гонке',

    raffleTitle: 'Розыгрыш недели',
    raffleEmpty: 'На этой неделе розыгрыша нет',
    raffleMyInvestedLabel: 'Вложено',
    raffleParticipantsLabel: 'Участвует',
    raffleParticipantOne: 'участник',
    raffleParticipantFew: 'участника',
    raffleParticipantMany: 'участников',
    raffleInvestButton: 'Вложить',
    raffleGoToQuestsButton: 'К заданиям',
    raffleEndedButton: 'Раунд завершён',
    raffleWinnersLink: 'Победители',

    investSheetTitle: 'Вклад в розыгрыш',
    investSheetLockedBody: 'Вступи в SHOT BAND, чтобы вкладывать в еженедельный розыгрыш.',
    investSheetJoinButton: 'Вступить',
    investSheetEndedBody: 'Этот раунд уже завершён — дождись следующего.',
    investSheetNoBalanceBody: 'Пока нечего вкладывать — выполняй задания дня, чтобы получить.',
    investSheetDecrease: 'Уменьшить',
    investSheetIncrease: 'Увеличить',
    investSheetBalanceHint: 'Доступно: {{balance}}',
    investSheetDisclaimer: 'Вложенное не возвращается — довложить можно в любой момент.',
    investSheetErrorGeneric: 'Не удалось вложить. Попробуй ещё раз.',
    investSheetSubmitButton: 'Вложить',
  },
  uz: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND yuklanmoqda...',

    heroWelcome: 'Xush kelibsan',
    heroMemberBadge: 'SHOT BAND aʼzosi',
    heroDaysLeftOne: '{{count}} kun qoldi',
    heroDaysLeftFew: '{{count}} kun qoldi',
    heroDaysLeftMany: '{{count}} kun qoldi',
    heroDaysLeftZero: 'Aʼzolik bugun tugaydi',
    heroRenewButton: 'Uzaytirish',
    heroOfferTitlePrefix: 'Hisob',
    heroOfferTitleSuffix: 'ga toʻldirish klubni yoqadi — shu yerda ham, oddiy toʻldirishda ham.',
    heroOfferBody: '4% gacha keshbek — daraja bilan oʻsadi, kunlik topshiriqlar va pichoq lotereyasi.',
    heroOfferFinePrint: 'Butun summa oʻyin balansingga tushadi. Uni keyslarga, kontraktlarga, oʻyinlarga va upgreydlarga xohlaganingcha sarflaysan.',
    heroJoinButton: 'Qoʻshilish —',
    heroHowItWorks: 'Bu qanday ishlaydi',

    rulesTitle: 'SHOT BAND qanday ishlaydi',
    rule1Prefix: 'Bir martalik ',
    rule1Suffix: " toʻlov bilan 28 kunga SHOT BANDʼga aʼzo boʻlasan. Tangalar odatdagidek balansingga tushadi.",
    rule1Title: 'Klubga kirish',
    rule2Title: '4% gacha keshbek',
    rule2: 'Tangaga har bir oʻyin uchqunlar bilan keshbek qaytaradi. Foiz daraja bilan oʻsadi — 10-darajada 1%, 100-darajada 4%. Har 7 kunda olib tur.',
    rule3Title: 'Uchqunga keyslar',
    rule3Prefix: 'Uchqunlar ',
    rule3Suffix: " SHOT BAND keyslarini ochadi — ichida pichoqlargacha skinlar.",
    rule4Title: 'Topshiriqlar va strik',
    rule4Prefix: 'Kunlik topshiriqlar ',
    rule4Mid: " beradi. 7 kunlik strikni saqla — bonus sifatida +10 ",
    rule4Suffix: '.',
    rule5Title: 'Pichoq lotereyasi',
    rule5Prefix: 'Har hafta pichoq oʻynaymiz. Oʻz ',
    rule5Suffix: 'laringni qoʻy — bilet koʻp boʻlsa, imkoniyat yuqori.',
    rule6Title: 'Kun poygasi',
    rule6: 'Yarim tungacha (MSK) tangaga eng koʻp oʻynagan kun skinini oladi. Har kuni yangi sovgʻa.',
    rule7Title: 'Aylanma uchun bepul keyslar',
    rule7: 'Kunlik aylanma keyslarni bepul ochadi — qancha koʻp oʻynasang, bepul keys shuncha qimmat. Har kuni, istalgan keysgacha.',

    ticketSheetTitleJoin: "SHOT BANDʼga qoʻshilish",
    ticketSheetTitleRenew: 'SHOT BAND aʼzoligini uzaytirish',
    ticketSheetTopupNotePrefix: 'Balansingga darhol',
    ticketSheetTopupNoteSuffix: 'tushadi — klub sovgʻa sifatida beriladi.',
    ticketSheetRenewDisclaimer: 'Uzaytirish joriy muddatga qoʻshiladi — plyus 28 kun.',
    ticketSheetRenewTooEarly: 'Uzaytirish aʼzolik tugashiga bir kun qolganda ochiladi — shu muddatga yaqinroq kel.',
    ticketSheetBuyButton: 'Toʻlash',
    ticketSheetLoadingProviders: 'Toʻlov usullari yuklanmoqda...',
    ticketSheetNoProviders: 'Hozircha toʻlov usullari mavjud emas.',
    ticketSheetErrorTitle: "Hisob yaratilmadi",
    ticketSheetErrorHint: 'Qayta urinib koʻr yoki boshqa usulni tanla',
    ticketSheetLoadErrorGeneric: 'Toʻlov usullarini yuklab boʻlmadi.',
    ticketSheetPriceUnavailable: 'Bu toʻlov usuli uchun narx mavjud emas — boshqasini tanla.',
    ticketSheetCardConfirmTitle: 'Toʻlovni tasdiqla',
    ticketSheetCardConfirmMessage: "SHOT BANDʼga qoʻshilish uchun {{card}} kartadan {{amount}} yechilsinmi?",
    ticketSheetCardConfirmOk: 'Toʻlash',
    ticketSheetCardPending: 'Click toʻlovni hali tasdiqlamoqda — aʼzolik avtomatik yoqiladi.',
    ticketSheetCardErrorTitle: 'Toʻlov oʻtmadi',
    ticketSheetCardErrorHint: 'Qayta urinib koʻr; pul kartadan yechilgan boʻlsa, qoʻllab-quvvatlashga yoz',

    cashbackBalanceLabel: 'Klub balansi',
    cashbackCoinsLabel: 'Uchqunlar',
    cashbackTicketsLabel: 'Chiptalar',
    cashbackNextPayoutLabel: 'Keyingi toʻlov:',
    mechanicNameCase: 'Keyslar',
    mechanicNameBattle: 'Battlar',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Ruletka',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Kontraktlar',
    cashbackChipPrefix: 'keshbek',
    cashbackChipLocked: 'keshbek {{level}}-darajadan',
    cashbackSpendButton: 'Sarflash',
    cashbackInvestButton: 'Qoʻyish',
    cashbackFrozenNote: 'Aʼzoliging tugadi — uchqunlaring ham, chiptalaring ham sendaligicha qoldi. Uchqunlarni hozir ham yigʻib olsang boʻladi, sarflash va chipta qoʻyish esa faqat klub ichida.',
    cashbackUnlockButton: 'Qaytish',
    cashbackClaimReadyLabel: 'Keshbek tayyor:',
    cashbackClaimButton: 'Olish',
    cashbackTimerLabel: 'ichida',

    streakDayLabel: '{{day}}-kun / 7 kun',
    streakHint: '{{days}} kun ketma-ket — bonus',

    freeCasesTitle: 'Bepul keys',
    freeCasesTurnoverLabel: 'Bugungi aylanma',
    freeCasesNextHintPrefix: 'Yana',
    freeCasesNextHintSuffix: "aylanma — va uni bepul ochasan",
    freeCasesReadyHint: 'Bepul ochish mumkin — ol!',
    freeCasesAllClaimed: "Bugungi barcha bepul ochishlar ishlatildi — yangilari yangilanishdan keyin",
    freeCasesTimerBurnOpen: "Ochmasang — yonib ketadi",
    freeCasesTimerBurnProgress: "Aylanma progressi yonib ketadi",
    freeCasesTimerPlain: 'Kun yangilanishigacha',
    freeCasesTimerNew: 'Yangi bepul ochishlar',
    freeCasesOpenFreeButton: 'Ochish',
    freeCasesRulesTitle: 'Bepul keys qoidalari',
    freeCasesRulesWagerTitle: 'Tangaga oʻyna',
    freeCasesRulesWagerBody: 'Tangaga har qanday oʻyin kunlik aylanmaga hisoblanadi — keyslar, janglar, upgreydlar, kontraktlar, Rush Mid, ruletka.',
    freeCasesRulesOpenTitle: 'Chegaraga yetding — bepul ochasan',
    freeCasesRulesOpenBody: 'Har bir keysning oʻz aylanma chegarasi bor. Yetib olding — ochish klub hisobidan. Har keysga kuniga bitta bepul ochish.',
    freeCasesRulesResetTitle: 'Yarim tunda hammasi yonadi',
    freeCasesRulesResetBody: "Moskva vaqti bilan yarim tunda kun yangilanadi: aylanma progressi va olinmagan bepul ochishlar yonib ketadi. Yangi kun — noldan.",

    questsTitle: 'Kunlik topshiriqlar',
    questsResetLabel: "Yangi topshiriqlargacha",
    questClaimButton: 'Olish',
    questsLockedJoinButton: 'Qoʻshilish',
    questGenericTitle: 'Kunlik topshiriq',
    questCompletedToastOverline: 'Topshiriq bajarildi!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '',
    quest_open_3_cases_2500_suffix: "dan qimmat 3 ta keys och",
    quest_open_3_cases_2500_unit: 'keys',
    quest_rush_3_matches_prefix: "Rush Midʼda 3 ta matchda oʻyna",
    quest_rush_3_matches_unit: 'match',
    quest_open_band_case_prefix: 'SHOT BAND keysini och',
    quest_open_band_case_unit: 'keys',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: ' aylantir',
    quest_battles_2_5k_prefix: 'Kirish toʻlovi',
    quest_battles_2_5k_suffix: 'dan yuqori boʻlgan 2 ta jangda oʻyna',
    quest_battles_2_5k_unit: 'jang',
    quest_upgrades_3_2500_prefix: '',
    quest_upgrades_3_2500_suffix: 'dan qimmat 3 ta apgreyd qil',
    quest_upgrades_3_2500_unit: 'apgreyd',
    quest_contract_10k_prefix: '',
    quest_contract_10k_suffix: 'dan qimmat kontrakt tuz',
    quest_contract_10k_unit: 'kontrakt',
    quest_win_battle_prefix: 'Jangda gʻalaba qozon',
    quest_win_battle_unit: 'jang',
    quest_win_upgrade_prefix: 'Apgreydda yutib chiq',
    quest_win_upgrade_unit: 'apgreyd',
    quest_open_case_12500_prefix: '',
    quest_open_case_12500_suffix: 'dan qimmat keys och',
    quest_open_case_12500_unit: 'keys',
    quest_open_5_cases_1000_prefix: '',
    quest_open_5_cases_1000_suffix: 'dan qimmat 5 ta keys och',
    quest_open_5_cases_1000_unit: 'keys',
    quest_roulette_play_prefix: 'Ruletka turida oʻyna',
    quest_roulette_play_unit: 'tur',
    quest_contracts_25k_sum_prefix: 'Jami',
    quest_contracts_25k_sum_suffix: 'lik kontraktlar tuz',
    quest_upgrades_15k_sum_prefix: 'Jami',
    quest_upgrades_15k_sum_suffix: 'lik apgreydlar qil',
    quest_rush_5_matches_prefix: "Rush Midʼda 5 ta matchda oʻyna",
    quest_rush_5_matches_unit: 'match',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: ' aylantir',
    quest_wager_10k_battles_prefix: 'Janglarda',
    quest_wager_10k_battles_suffix: ' aylantir',
    quest_wager_10k_rush_prefix: "Rush Midʼda",
    quest_wager_10k_rush_suffix: ' aylantir',
    quest_wager_10k_roulette_prefix: 'Ruletkada',
    quest_wager_10k_roulette_suffix: ' aylantir',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: ' aylantir',
    quest_rush_mid_win_prefix: "Rush Midʼda gʻalaba qozon",
    quest_rush_mid_win_unit: 'gʻalaba',
    quest_big_drop_25k_prefix: 'Keysdan',
    quest_big_drop_25k_suffix: 'dan qimmat buyum tushir',
    quest_big_drop_25k_unit: 'buyum',
    quest_risky_upgrade_35_prefix: 'Ehtimolligi 35% gacha boʻlgan apgreydda yutib chiq',
    quest_risky_upgrade_35_unit: 'apgreyd',
    quest_covert_drop_prefix: 'Keysdan Covert buyum tushir',
    quest_covert_drop_unit: 'buyum',

    raceTitle: 'Kunlik poyga',
    raceEmpty: 'Bugun poyga yoʻq — keyinroq kir',
    rulesLinkLabel: 'Qoidalar',
    raceRulesTitle: 'Kunlik poyga qoidalari',
    raceRulesPlayTitle: 'Qanday gʻalaba qozonish',
    raceRulesPlayBody: "SHOTʼda istalgan oʻyinni oʻyna — keyslar, apgreydlar, kontraktlar, janglar, Rush Mid, ruletka. Oʻyinlarga sarflangan tangalar hisoblanadi: kunlik aylanmasi eng katta boʻlgan yutadi.",
    raceRulesPrizeTitle: 'Sovgʻa',
    raceRulesPrizeBody: 'Har kuni yangi skin. Yarim tunda (MSK) u birinchi oʻringa beriladi va darhol inventarga tushadi.',
    raceRulesMembersTitle: "Faqat klub uchun",
    raceRulesMembersBody: 'Poyga — SHOT BAND aʼzolari uchun. Oʻyin avtomatik hisoblanadi, hech narsani yoqish shart emas.',
    raffleRulesTitle: 'Haftalik lotereya qoidalari',
    raffleRulesTicketsTitle: 'Chiptalarni yig',
    raffleRulesTicketsBodyPrefix: 'Kunlik topshiriqlarni bajar — ular uchun lotereya chiptalari',
    raffleRulesTicketsBodySuffix: 'beriladi.',
    raffleRulesChanceTitle: 'Qoʻy va imkoniyatni oshir',
    raffleRulesChanceBody: 'Chiptalarni turga qoʻy — qancha koʻp qoʻysang, imkoniyat shuncha yuqori. Qoʻyilganlar qaytarilmaydi, yana qoʻshish mumkin.',
    raffleRulesFinalTitle: 'Final',
    raffleRulesFinalBody: 'Tur bir hafta davom etadi. Gʻolibni tasodif tanlaydi, skin darhol inventarga tushadi.',
    racePrizeLabel: 'Kun sovgʻasi',
    raceYourPlace: 'Sening oʻrning',
    raceParticipantsLabel: 'Ishtirok etyapti',
    raceNotWagered: 'Bugun istalgan oʻyinni oʻyna — va sen poygadasan',

    raffleTitle: 'Haftalik lotereya',
    raffleEmpty: 'Bu hafta lotereya yoʻq',
    raffleMyInvestedLabel: 'Qoʻyilgan',
    raffleParticipantsLabel: 'Ishtirok etyapti',
    raffleParticipantOne: 'ishtirokchi',
    raffleParticipantFew: 'ishtirokchi',
    raffleParticipantMany: 'ishtirokchi',
    raffleInvestButton: 'Qoʻyish',
    raffleGoToQuestsButton: 'Topshiriqlarga',
    raffleEndedButton: 'Tur tugadi',
    raffleWinnersLink: 'Gʻoliblar',

    investSheetTitle: 'Lotereyaga qoʻyish',
    investSheetLockedBody: "Haftalik lotereyaga qoʻyish uchun SHOT BANDʼga qoʻshil.",
    investSheetJoinButton: 'Qoʻshilish',
    investSheetEndedBody: 'Bu tur allaqachon tugadi — keyingisini kut.',
    investSheetNoBalanceBody: 'Hozircha qoʻyadigan narsa yoʻq — kunlik topshiriqlarni bajarib ol.',
    investSheetDecrease: 'Kamaytirish',
    investSheetIncrease: 'Oshirish',
    investSheetBalanceHint: 'Mavjud: {{balance}}',
    investSheetDisclaimer: 'Qoʻyilganlar qaytarilmaydi — istalgan payt yana qoʻshishing mumkin.',
    investSheetErrorGeneric: 'Qoʻyib boʻlmadi. Qayta urinib koʻr.',
    investSheetSubmitButton: 'Qoʻyish',
  },
  fa: {
    title: 'SHOT BAND',
    loading: 'در حال بارگذاری SHOT BAND...',

    heroWelcome: 'خوش آمدی به',
    heroMemberBadge: 'عضو SHOT BAND',
    heroDaysLeftOne: '{{count}} روز مانده',
    heroDaysLeftFew: '{{count}} روز مانده',
    heroDaysLeftMany: '{{count}} روز مانده',
    heroDaysLeftZero: 'عضویت امروز تمام می‌شود',
    heroRenewButton: 'تمدید',
    heroOfferTitlePrefix: '',
    heroOfferTitleSuffix: 'شارژ کن تا باشگاه روشن شود — همین‌جا یا در هر شارژی.',
    heroOfferBody: 'کش‌بک تا 4% — با سطحت بالا می‌رود — مأموریت روزانه و شانس قرعه‌کشی چاقو.',
    heroOfferFinePrint: 'کل مبلغ روی موجودی بازیت می‌نشیند. هرطور خواستی خرجش کن: کیس، قرارداد، بازی و ارتقا.',
    heroJoinButton: 'عضو شو با',
    heroHowItWorks: 'چطور کار می‌کند',

    rulesTitle: 'SHOT BAND چطور کار می‌کند',
    rule1Prefix: '',
    rule1Suffix: ' را یک‌جا شارژ کن — 28 روز عضو SHOT BAND هستی. سکه‌ها مثل همیشه به موجودیت می‌آیند.',
    rule1Title: 'عضویت در SHOT BAND',
    rule2Title: 'کش‌بک تا 4%',
    rule2:
      'هر بازی سکه‌ای کش‌بک می‌دهد، به شکل جرقه. نرخش با سطحت بالا می‌رود — 1% در سطح 10، 4% در سطح 100. هر 7 روز بگیرش.',
    rule3Title: 'کیس با جرقه',
    rule3Prefix: '',
    rule3Suffix: ' کیس‌های SHOT BAND را باز می‌کند — اسکین تا خود چاقو.',
    rule4Title: 'مأموریت و زنجیره',
    rule4Prefix: 'مأموریت‌های روزانه ',
    rule4Mid: ' می‌دهند. زنجیره 7 روزه را نگه دار — +10 ',
    rule4Suffix: ' بونوس بگیر.',
    rule5Title: 'قرعه‌کشی هفتگی چاقو',
    rule5Prefix: 'هر هفته یک چاقو قرعه‌کشی می‌کنیم. ',
    rule5Suffix: ' خودت را سرمایه‌گذاری کن — بلیت بیشتر، شانس بیشتر.',
    rule6Title: 'رقابت روزانه',
    rule6: 'تا نیمه‌شب (به وقت مسکو) بیشترین سکه را بازی کن و اسکین آن روز را ببر. هر روز، جایزه‌ای تازه.',
    rule7Title: 'کیس رایگان برای گردش',
    rule7:
      'گردش روزانه‌ات کیس‌های قفسه را رایگان باز می‌کند — هرچه بیشتر بازی کنی، کیس رایگان بهتری می‌گیری. تا سقف همه کیس‌ها، هر روز.',

    ticketSheetTitleJoin: 'عضویت در SHOT BAND',
    ticketSheetTitleRenew: 'تمدید SHOT BAND',
    ticketSheetTopupNotePrefix: 'همان لحظه',
    ticketSheetTopupNoteSuffix: 'به موجودیت می‌نشیند — باشگاه هدیه است.',
    ticketSheetRenewDisclaimer: 'تمدید 28 روز به مدت عضویت فعلیت اضافه می‌کند.',
    ticketSheetRenewTooEarly: 'تمدید یک روز پیش از پایان عضویت باز می‌شود — نزدیک آن تاریخ برگرد.',
    ticketSheetBuyButton: 'پرداخت',
    ticketSheetLoadingProviders: 'در حال بارگذاری روش‌های پرداخت...',
    ticketSheetNoProviders: 'الان روش پرداختی در دسترس نیست.',
    ticketSheetErrorTitle: 'فاکتور ساخته نشد',
    ticketSheetErrorHint: 'دوباره تلاش کن یا روش دیگری انتخاب کن',
    ticketSheetLoadErrorGeneric: 'روش‌های پرداخت بارگذاری نشدند.',
    ticketSheetPriceUnavailable: 'برای این روش پرداخت قیمتی نیست — یکی دیگر امتحان کن.',
    ticketSheetCardConfirmTitle: 'تأیید پرداخت',
    ticketSheetCardConfirmMessage: 'برای عضویت در SHOT BAND، {{amount}} از {{card}} کسر شود؟',
    ticketSheetCardConfirmOk: 'پرداخت',
    ticketSheetCardPending: 'Click هنوز پرداخت را تأیید می‌کند — عضویتت خودکار روشن می‌شود.',
    ticketSheetCardErrorTitle: 'پرداخت انجام نشد',
    ticketSheetCardErrorHint: 'دوباره تلاش کن؛ اگر پول از کارتت کم شد با پشتیبانی تماس بگیر',

    cashbackBalanceLabel: 'موجودی باشگاه',
    cashbackCoinsLabel: 'جرقه',
    cashbackTicketsLabel: 'بلیت',
    cashbackNextPayoutLabel: 'پرداخت بعدی:',
    mechanicNameCase: 'کیس‌ها',
    mechanicNameBattle: 'نبردها',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'رولت',
    mechanicNameUpgrade: 'ارتقاها',
    mechanicNameContract: 'قراردادها',
    cashbackChipPrefix: 'کش‌بک',
    cashbackChipLocked: 'کش‌بک از سطح {{level}}',
    cashbackSpendButton: 'خرج کن',
    cashbackInvestButton: 'سرمایه‌گذاری',
    cashbackFrozenNote: 'عضویتت تمام شد — جرقه‌ها و بلیت‌هایت مال خودت می‌مانند. جرقه‌ها را همچنان می‌توانی بگیری، اما خرج‌کردنشان و گذاشتن بلیت فقط داخل باشگاه ممکن است.',
    cashbackUnlockButton: 'بازگشت',
    cashbackClaimReadyLabel: 'کش‌بک آماده است:',
    cashbackClaimButton: 'بگیر',
    cashbackTimerLabel: 'تا',

    streakDayLabel: 'روز {{day}} از 7',
    streakHint: '{{days}} روز پشت سر هم — بونوس',

    freeCasesTitle: 'کیس رایگان',
    freeCasesTurnoverLabel: 'گردش امروز',
    freeCasesNextHintPrefix: '',
    freeCasesNextHintSuffix: 'دیگر بازی کن تا رایگان بازش کنی',
    freeCasesReadyHint: 'رایگان است — بازش کن!',
    freeCasesAllClaimed: 'همه بازکردن‌های رایگان امروز خرج شد — بعد از ریست تازه می‌شوند',
    freeCasesTimerBurnOpen: 'بازکردن رایگان با ریست می‌سوزد',
    freeCasesTimerBurnProgress: 'پیشرفت گردش با ریست می‌سوزد',
    freeCasesTimerPlain: 'ریست روز تا',
    freeCasesTimerNew: 'بازکردن‌های رایگان تازه تا',
    freeCasesOpenFreeButton: 'باز کن',
    freeCasesRulesTitle: 'قوانین کیس رایگان',
    freeCasesRulesWagerTitle: 'با سکه بازی کن',
    freeCasesRulesWagerBody:
      'هر بازی سکه‌ای در گردش روزانه‌ات حساب می‌شود — کیس، نبرد، ارتقا، قرارداد، Rush Mid، رولت.',
    freeCasesRulesOpenTitle: 'به آستانه برس — رایگان باز کن',
    freeCasesRulesOpenBody:
      'هر کیس آستانه گردش خودش را دارد. بهش برسی، باشگاه هزینه بازکردن را می‌دهد. هر کیس، روزی یک بازکردن رایگان.',
    freeCasesRulesResetTitle: 'نیمه‌شب همه‌چیز می‌سوزد',
    freeCasesRulesResetBody:
      'نیمه‌شب (به وقت مسکو) روز ریست می‌شود: پیشرفت گردش و بازکردن‌های رایگان نگرفته می‌سوزند. روز بعد از صفر.',

    questsTitle: 'مأموریت‌های روزانه',
    questsResetLabel: 'مأموریت‌های تازه تا',
    questClaimButton: 'بگیر',
    questsLockedJoinButton: 'عضو شو',
    questGenericTitle: 'مأموریت روزانه',
    questCompletedToastOverline: 'مأموریت انجام شد!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '3 کیس',
    quest_open_3_cases_2500_suffix: 'به بالا باز کن',
    quest_open_3_cases_2500_unit: 'کیس',
    quest_rush_3_matches_prefix: '3 مسابقه Rush Mid بازی کن',
    quest_rush_3_matches_unit: 'مسابقه',
    quest_open_band_case_prefix: 'یک کیس SHOT BAND باز کن',
    quest_open_band_case_unit: 'کیس',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: 'بازی کن',
    quest_battles_2_5k_prefix: '2 نبرد کیس با ورودی',
    quest_battles_2_5k_suffix: 'به بالا بازی کن',
    quest_battles_2_5k_unit: 'نبرد',
    quest_upgrades_3_2500_prefix: '3 ارتقا به ارزش',
    quest_upgrades_3_2500_suffix: 'به بالا بزن',
    quest_upgrades_3_2500_unit: 'ارتقا',
    quest_contract_10k_prefix: 'یک قرارداد به ارزش',
    quest_contract_10k_suffix: 'به بالا ببند',
    quest_contract_10k_unit: 'قرارداد',
    quest_win_battle_prefix: 'یک نبرد کیس ببر',
    quest_win_battle_unit: 'نبرد',
    quest_win_upgrade_prefix: 'یک ارتقا ببر',
    quest_win_upgrade_unit: 'ارتقا',
    quest_open_case_12500_prefix: 'یک کیس به ارزش',
    quest_open_case_12500_suffix: 'به بالا باز کن',
    quest_open_case_12500_unit: 'کیس',
    quest_open_5_cases_1000_prefix: '5 کیس',
    quest_open_5_cases_1000_suffix: 'به بالا باز کن',
    quest_open_5_cases_1000_unit: 'کیس',
    quest_roulette_play_prefix: 'یک دور رولت بازی کن',
    quest_roulette_play_unit: 'دور',
    quest_contracts_25k_sum_prefix: 'روی‌هم قرارداد به ارزش',
    quest_contracts_25k_sum_suffix: 'ببند',
    quest_upgrades_15k_sum_prefix: 'روی‌هم ارتقا به ارزش',
    quest_upgrades_15k_sum_suffix: 'بزن',
    quest_rush_5_matches_prefix: '5 مسابقه Rush Mid بازی کن',
    quest_rush_5_matches_unit: 'مسابقه',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: 'بازی کن',
    quest_wager_10k_battles_prefix: '',
    quest_wager_10k_battles_suffix: 'در نبرد کیس بازی کن',
    quest_wager_10k_rush_prefix: '',
    quest_wager_10k_rush_suffix: 'در Rush Mid بازی کن',
    quest_wager_10k_roulette_prefix: '',
    quest_wager_10k_roulette_suffix: 'در رولت بازی کن',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: 'بازی کن',
    quest_rush_mid_win_prefix: 'یک مسابقه Rush Mid ببر',
    quest_rush_mid_win_unit: 'برد',
    quest_big_drop_25k_prefix: 'از یک کیس آیتمی گران‌تر از',
    quest_big_drop_25k_suffix: 'در بیاور',
    quest_big_drop_25k_unit: 'آیتم',
    quest_risky_upgrade_35_prefix: 'یک ارتقا با شانس 35% یا کمتر ببر',
    quest_risky_upgrade_35_unit: 'ارتقا',
    quest_covert_drop_prefix: 'از یک کیس آیتم Covert در بیاور',
    quest_covert_drop_unit: 'آیتم',

    raceTitle: 'رقابت روزانه',
    raceEmpty: 'امروز رقابتی نیست — بعداً سر بزن',
    rulesLinkLabel: 'قوانین',
    raceRulesTitle: 'قوانین رقابت روزانه',
    raceRulesPlayTitle: 'چطور ببریم',
    raceRulesPlayBody:
      'هر چیزی در SHOT بازی کن — کیس، ارتقا، قرارداد، نبرد، Rush Mid، رولت. سکه‌ای که خرج بازی می‌کنی حساب می‌شود: بیشترین گردش روزانه می‌برد.',
    raceRulesPrizeTitle: 'جایزه',
    raceRulesPrizeBody:
      'هر روز یک اسکین تازه. نیمه‌شب (به وقت مسکو) به نفر اول می‌رسد و مستقیم در انبارش می‌افتد.',
    raceRulesMembersTitle: 'فقط اعضا',
    raceRulesMembersBody: 'رقابت برای اعضای SHOT BAND است. بازیت خودکار حساب می‌شود — چیزی لازم نیست فعال کنی.',
    raffleRulesTitle: 'قوانین قرعه‌کشی هفتگی',
    raffleRulesTicketsTitle: 'بلیت جمع کن',
    raffleRulesTicketsBodyPrefix: 'مأموریت‌های روزانه را انجام بده تا بلیت قرعه‌کشی بگیری',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'سرمایه‌گذاری کن تا شانست بالا برود',
    raffleRulesChanceBody:
      'بلیت‌ها را در دور سرمایه‌گذاری کن — هرچه بیشتر بگذاری، شانست بیشتر است. بلیت سرمایه‌گذاری‌شده برنمی‌گردد، اما همیشه می‌توانی بیشتر بگذاری.',
    raffleRulesFinalTitle: 'فینال',
    raffleRulesFinalBody: 'هر دور یک هفته است. برنده تصادفی انتخاب می‌شود و اسکین مستقیم در انبارش می‌افتد.',
    racePrizeLabel: 'جایزه امروز',
    raceYourPlace: 'جایگاه تو',
    raceParticipantsLabel: 'در حال بازی',
    raceNotWagered: 'امروز هر چیزی بازی کن تا وارد رقابت شوی',

    raffleTitle: 'قرعه‌کشی هفتگی',
    raffleEmpty: 'این هفته قرعه‌کشی در جریان نیست',
    raffleMyInvestedLabel: 'سرمایه‌گذاری تو',
    raffleParticipantsLabel: 'در حال بازی',
    raffleParticipantOne: 'شرکت‌کننده',
    raffleParticipantFew: 'شرکت‌کننده',
    raffleParticipantMany: 'شرکت‌کننده',
    raffleInvestButton: 'سرمایه‌گذاری',
    raffleGoToQuestsButton: 'رفتن به مأموریت‌ها',
    raffleEndedButton: 'دور تمام شد',
    raffleWinnersLink: 'برندگان',

    investSheetTitle: 'سرمایه‌گذاری در قرعه‌کشی',
    investSheetLockedBody: 'برای سرمایه‌گذاری در قرعه‌کشی هفتگی به SHOT BAND بپیوند.',
    investSheetJoinButton: 'عضو شو',
    investSheetEndedBody: 'این دور تمام شد — منتظر دور بعدی بمان.',
    investSheetNoBalanceBody: 'هنوز چیزی برای سرمایه‌گذاری نداری — مأموریت‌های روزانه را انجام بده.',
    investSheetDecrease: 'کم کن',
    investSheetIncrease: 'زیاد کن',
    investSheetBalanceHint: '{{balance}} در دسترس',
    investSheetDisclaimer: 'مبلغ سرمایه‌گذاری‌شده برنمی‌گردد — همیشه می‌توانی بیشتر بگذاری.',
    investSheetErrorGeneric: 'سرمایه‌گذاری نشد. دوباره تلاش کن.',
    investSheetSubmitButton: 'سرمایه‌گذاری',
  },
  pt: {
    title: 'SHOT BAND',
    loading: 'Carregando SHOT BAND...',

    heroWelcome: 'Bem-vindo ao',
    heroMemberBadge: 'Você está no SHOT BAND',
    heroDaysLeftOne: 'Falta {{count}} dia',
    heroDaysLeftFew: 'Faltam {{count}} dias',
    heroDaysLeftMany: 'Faltam {{count}} dias',
    heroDaysLeftZero: 'A assinatura termina hoje',
    heroRenewButton: 'Renovar',
    heroOfferTitlePrefix: 'Um depósito de',
    heroOfferTitleSuffix: 'ativa o clube — aqui ou em qualquer depósito.',
    heroOfferBody: 'Cashback de até 4% — cresce com o nível —, missões diárias e uma chance de ganhar uma faca no sorteio.',
    heroOfferFinePrint: 'O valor inteiro cai no seu saldo de jogo. Gaste em caixas, contratos, jogos e upgrades como quiser.',
    heroJoinButton: 'Entrar por',
    heroHowItWorks: 'Como funciona',

    rulesTitle: 'Como funciona o SHOT BAND',
    rule1Prefix: 'Deposite ',
    rule1Suffix: ' em um único pagamento — você entra no SHOT BAND por 28 dias. As moedas caem no seu saldo como sempre.',
    rule1Title: 'Entrada no SHOT BAND',
    rule2Title: 'Cashback de até 4%',
    rule2: 'Todo jogo com moedas devolve cashback em faíscas. A taxa cresce com o nível — 1% no nível 10, 4% no nível 100. Resgate a cada 7 dias.',
    rule3Title: 'Caixas por faíscas',
    rule3Prefix: 'As faíscas ',
    rule3Suffix: ' abrem caixas SHOT BAND — skins que vão até facas.',
    rule4Title: 'Missões e sequência',
    rule4Prefix: 'As missões diárias rendem ',
    rule4Mid: '. Mantenha uma sequência de 7 dias — ganhe +10 ',
    rule4Suffix: ' de bônus.',
    rule5Title: 'Sorteio semanal de faca',
    rule5Prefix: 'Toda semana sorteamos uma faca. Invista seus ',
    rule5Suffix: ' — quanto mais bilhetes, maior a chance.',
    rule6Title: 'Corrida do dia',
    rule6: 'Jogue mais moedas que todo mundo até a meia-noite (MSK) — e a skin do dia é sua. Todo dia um prêmio novo.',
    rule7Title: 'Caixas grátis por volume',
    rule7: 'O volume jogado no dia abre as caixas da prateleira de graça — quanto mais você joga, mais cara a caixa grátis. Pode ser todas as caixas, todos os dias.',

    ticketSheetTitleJoin: 'Entrar no SHOT BAND',
    ticketSheetTitleRenew: 'Renovar o SHOT BAND',
    ticketSheetTopupNotePrefix: 'Seu saldo recebe',
    ticketSheetTopupNoteSuffix: 'na hora — o clube vem de presente.',
    ticketSheetRenewDisclaimer: 'A renovação soma 28 dias ao prazo atual da assinatura.',
    ticketSheetRenewTooEarly: 'A renovação abre um dia antes do fim da assinatura — volte perto dessa data.',
    ticketSheetBuyButton: 'Pagar',
    ticketSheetLoadingProviders: 'Carregando formas de pagamento...',
    ticketSheetNoProviders: 'Nenhuma forma de pagamento disponível no momento.',
    ticketSheetErrorTitle: 'Não foi possível criar a fatura',
    ticketSheetErrorHint: 'Tente de novo ou escolha outra forma',
    ticketSheetLoadErrorGeneric: 'Não foi possível carregar as formas de pagamento.',
    ticketSheetPriceUnavailable: 'Preço indisponível para esta forma de pagamento — escolha outra.',
    ticketSheetCardConfirmTitle: 'Confirme o pagamento',
    ticketSheetCardConfirmMessage: 'Cobrar {{amount}} do cartão {{card}} pelo passe do SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pagar',
    ticketSheetCardPending: 'O Click ainda está confirmando o pagamento — a assinatura será ativada automaticamente.',
    ticketSheetCardErrorTitle: 'O pagamento não passou',
    ticketSheetCardErrorHint: 'Tente de novo; se o dinheiro saiu do cartão, fale com o suporte',

    cashbackBalanceLabel: 'Saldo do clube',
    cashbackCoinsLabel: 'Faíscas',
    cashbackTicketsLabel: 'Bilhetes',
    cashbackNextPayoutLabel: 'Próximo pagamento:',
    mechanicNameCase: 'Caixas',
    mechanicNameBattle: 'Batalhas',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roleta',
    mechanicNameUpgrade: 'Upgrades',
    mechanicNameContract: 'Contratos',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback a partir do nível {{level}}',
    cashbackSpendButton: 'Gastar',
    cashbackInvestButton: 'Investir',
    cashbackFrozenNote: 'A assinatura acabou — as faíscas e os bilhetes continuam seus. Você ainda pode resgatar faíscas; gastar e investir bilhetes só com o clube ativo.',
    cashbackUnlockButton: 'Voltar',
    cashbackClaimReadyLabel: 'Cashback pronto:',
    cashbackClaimButton: 'Resgatar',
    cashbackTimerLabel: 'em',

    streakDayLabel: 'Dia {{day}} de 7',
    streakHint: '{{days}} dias seguidos — bônus',

    freeCasesTitle: 'Caixa grátis',
    freeCasesTurnoverLabel: 'Volume hoje',
    freeCasesNextHintPrefix: 'Mais',
    freeCasesNextHintSuffix: 'de volume — e você abre de graça',
    freeCasesReadyHint: 'Dá para abrir de graça — aproveite!',
    freeCasesAllClaimed: 'Tudo que era grátis hoje já foi aberto — novas aberturas após o reset',
    freeCasesTimerBurnOpen: 'Se não abrir até o reset, perde',
    freeCasesTimerBurnProgress: 'O progresso do volume some em',
    freeCasesTimerPlain: 'O dia reseta em',
    freeCasesTimerNew: 'Novas aberturas grátis em',
    freeCasesOpenFreeButton: 'Abrir',
    freeCasesRulesTitle: 'Regras da caixa grátis',
    freeCasesRulesWagerTitle: 'Jogue com moedas',
    freeCasesRulesWagerBody: 'Todo jogo com moedas entra no volume do dia — caixas, batalhas, upgrades, contratos, Rush Mid, roleta.',
    freeCasesRulesOpenTitle: 'Bateu a meta — abre de graça',
    freeCasesRulesOpenBody: 'Cada caixa tem sua própria meta de volume. Chegou lá — o clube paga a abertura. Uma abertura grátis por caixa por dia.',
    freeCasesRulesResetTitle: 'À meia-noite tudo zera',
    freeCasesRulesResetBody: 'À meia-noite (MSK) o dia reseta: o progresso do volume e as aberturas grátis não usadas somem. Novo dia — do zero.',

    questsTitle: 'Missões do dia',
    questsResetLabel: 'Novas missões em',
    questClaimButton: 'Resgatar',
    questsLockedJoinButton: 'Entrar',
    questGenericTitle: 'Missão diária',
    questCompletedToastOverline: 'Missão concluída!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Abra 3 caixas de',
    quest_open_3_cases_2500_suffix: 'ou mais',
    quest_open_3_cases_2500_unit: 'caixas',
    quest_rush_3_matches_prefix: 'Jogue 3 partidas de Rush Mid',
    quest_rush_3_matches_unit: 'partidas',
    quest_open_band_case_prefix: 'Abra uma caixa SHOT BAND',
    quest_open_band_case_unit: 'caixa',
    quest_wager_25k_prefix: 'Jogue',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Jogue 2 batalhas com entrada de',
    quest_battles_2_5k_suffix: 'ou mais',
    quest_battles_2_5k_unit: 'batalhas',
    quest_upgrades_3_2500_prefix: 'Faça 3 upgrades de',
    quest_upgrades_3_2500_suffix: 'ou mais',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Feche um contrato de',
    quest_contract_10k_suffix: 'ou mais',
    quest_contract_10k_unit: 'contrato',
    quest_win_battle_prefix: 'Vença uma batalha de caixas',
    quest_win_battle_unit: 'batalha',
    quest_win_upgrade_prefix: 'Vença um upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Abra uma caixa de',
    quest_open_case_12500_suffix: 'ou mais',
    quest_open_case_12500_unit: 'caixa',
    quest_open_5_cases_1000_prefix: 'Abra 5 caixas de',
    quest_open_5_cases_1000_suffix: 'ou mais',
    quest_open_5_cases_1000_unit: 'caixas',
    quest_roulette_play_prefix: 'Jogue uma rodada de roleta',
    quest_roulette_play_unit: 'rodada',
    quest_contracts_25k_sum_prefix: 'Feche contratos somando',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Faça upgrades somando',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Jogue 5 partidas de Rush Mid',
    quest_rush_5_matches_unit: 'partidas',
    quest_wager_50k_prefix: 'Jogue',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Jogue',
    quest_wager_10k_battles_suffix: 'em batalhas de caixas',
    quest_wager_10k_rush_prefix: 'Jogue',
    quest_wager_10k_rush_suffix: 'no Rush Mid',
    quest_wager_10k_roulette_prefix: 'Jogue',
    quest_wager_10k_roulette_suffix: 'na roleta',
    quest_wager_100k_prefix: 'Jogue',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Vença uma partida de Rush Mid',
    quest_rush_mid_win_unit: 'vitória',
    quest_big_drop_25k_prefix: 'Tire um item de mais de',
    quest_big_drop_25k_suffix: 'de uma caixa',
    quest_big_drop_25k_unit: 'item',
    quest_risky_upgrade_35_prefix: 'Vença um upgrade com chance de até 35%',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Tire um item Covert de uma caixa',
    quest_covert_drop_unit: 'item',

    raceTitle: 'Corrida do dia',
    raceEmpty: 'Hoje não tem corrida — volte mais tarde',
    rulesLinkLabel: 'Regras',
    raceRulesTitle: 'Regras da corrida do dia',
    raceRulesPlayTitle: 'Como vencer',
    raceRulesPlayBody: 'Jogue o que quiser no SHOT — caixas, upgrades, contratos, batalhas, Rush Mid, roleta. Contam as moedas gastas nos jogos: quem tiver o maior volume do dia vence.',
    raceRulesPrizeTitle: 'O prêmio',
    raceRulesPrizeBody: 'Todo dia uma skin nova. À meia-noite (MSK) ela vai para o primeiro lugar e cai direto no inventário.',
    raceRulesMembersTitle: 'Só para o clube',
    raceRulesMembersBody: 'A corrida é para membros do SHOT BAND. O jogo conta automaticamente — não precisa ativar nada.',
    raffleRulesTitle: 'Regras do sorteio da semana',
    raffleRulesTicketsTitle: 'Ganhe bilhetes',
    raffleRulesTicketsBodyPrefix: 'Complete as missões do dia — elas dão bilhetes',
    raffleRulesTicketsBodySuffix: 'do sorteio.',
    raffleRulesChanceTitle: 'Invista e aumente a chance',
    raffleRulesChanceBody: 'Invista bilhetes na rodada — quanto mais investir, maior a chance. O que foi investido não volta, mas dá para adicionar mais sempre.',
    raffleRulesFinalTitle: 'A final',
    raffleRulesFinalBody: 'A rodada dura uma semana. O vencedor é sorteado ao acaso e a skin cai direto no inventário.',
    racePrizeLabel: 'Prêmio do dia',
    raceYourPlace: 'Sua posição',
    raceParticipantsLabel: 'Jogando',
    raceNotWagered: 'Jogue qualquer coisa hoje — e você entra na corrida',

    raffleTitle: 'Sorteio da semana',
    raffleEmpty: 'Não há sorteio nesta semana',
    raffleMyInvestedLabel: 'Investido',
    raffleParticipantsLabel: 'Jogando',
    raffleParticipantOne: 'participante',
    raffleParticipantFew: 'participantes',
    raffleParticipantMany: 'participantes',
    raffleInvestButton: 'Investir',
    raffleGoToQuestsButton: 'Ir às missões',
    raffleEndedButton: 'Rodada encerrada',
    raffleWinnersLink: 'Vencedores',

    investSheetTitle: 'Investir no sorteio',
    investSheetLockedBody: 'Entre no SHOT BAND para investir no sorteio semanal.',
    investSheetJoinButton: 'Entrar',
    investSheetEndedBody: 'Esta rodada já terminou — espere a próxima.',
    investSheetNoBalanceBody: 'Ainda não há nada para investir — complete as missões do dia para ganhar.',
    investSheetDecrease: 'Diminuir',
    investSheetIncrease: 'Aumentar',
    investSheetBalanceHint: 'Disponível: {{balance}}',
    investSheetDisclaimer: 'O que foi investido não volta — dá para adicionar mais a qualquer momento.',
    investSheetErrorGeneric: 'Não foi possível investir. Tente de novo.',
    investSheetSubmitButton: 'Investir',
  },
  tr: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND yükleniyor...',

    heroWelcome: 'Hoş geldin',
    heroMemberBadge: "SHOT BAND'desin",
    heroDaysLeftOne: '{{count}} gün kaldı',
    heroDaysLeftFew: '{{count}} gün kaldı',
    heroDaysLeftMany: '{{count}} gün kaldı',
    heroDaysLeftZero: 'Üyelik bugün bitiyor',
    heroRenewButton: 'Uzat',
    heroOfferTitlePrefix: 'Kulüp,',
    heroOfferTitleSuffix: 'yatırınca açılır — burada ya da herhangi bir yatırmada.',
    heroOfferBody: "%4'e kadar cashback — seviyeyle büyür —, günlük görevler ve çekilişte bıçak kazanma şansı.",
    heroOfferFinePrint: "Tutarın tamamı oyun bakiyene düşer. Kasalara, kontratlara, oyunlara ve upgrade'lere istediğin gibi harca.",
    heroJoinButton: 'Katıl:',
    heroHowItWorks: 'Nasıl çalışır',

    rulesTitle: 'SHOT BAND nasıl çalışır',
    rule1Prefix: 'Tek ödemede ',
    rule1Suffix: " yatır — 28 gün boyunca SHOT BAND'desin. Coinler her zamanki gibi bakiyene düşer.",
    rule1Title: "SHOT BAND'e giriş",
    rule2Title: "%4'e kadar cashback",
    rule2: 'Coinle oynanan her oyun kıvılcım olarak cashback verir. Oran seviyeyle büyür — 10. seviyede %1, 100. seviyede %4. Her 7 günde bir al.',
    rule3Title: 'Kıvılcımla kasa',
    rule3Prefix: 'Kıvılcımlar ',
    rule3Suffix: ' SHOT BAND kasalarını açar — içinde bıçağa kadar skinler var.',
    rule4Title: 'Görevler ve seri',
    rule4Prefix: 'Günlük görevler ',
    rule4Mid: ' kazandırır. 7 günlük seriyi koru — bonus olarak +10 ',
    rule4Suffix: ' al.',
    rule5Title: 'Haftalık bıçak çekilişi',
    rule5Prefix: 'Her hafta bir bıçak çekiliyor. Biletlerini ',
    rule5Suffix: ' yatır — ne kadar çok bilet, o kadar yüksek şans.',
    rule6Title: 'Günün yarışı',
    rule6: 'Gece yarısına (MSK) kadar herkesten çok coin oyna — günün skini senin. Her gün yeni ödül.',
    rule7Title: 'Ciroya bedava kasa',
    rule7: 'Günlük ciro raftaki kasaları bedava açar — ne kadar çok oynarsan bedava kasa o kadar pahalı. İstersen tüm kasalar, istersen her gün.',

    ticketSheetTitleJoin: "SHOT BAND'e katıl",
    ticketSheetTitleRenew: "SHOT BAND'i uzat",
    ticketSheetTopupNotePrefix: 'Bakiyene hemen',
    ticketSheetTopupNoteSuffix: 'yatar — kulüp hediye.',
    ticketSheetRenewDisclaimer: 'Uzatma mevcut üyelik süresine eklenir — artı 28 gün.',
    ticketSheetRenewTooEarly: 'Uzatma, üyelik bitmeden bir gün önce açılır — o tarihe yakın tekrar gel.',
    ticketSheetBuyButton: 'Öde',
    ticketSheetLoadingProviders: 'Ödeme yöntemleri yükleniyor...',
    ticketSheetNoProviders: 'Şu anda kullanılabilir ödeme yöntemi yok.',
    ticketSheetErrorTitle: 'Fatura oluşturulamadı',
    ticketSheetErrorHint: 'Tekrar dene ya da başka bir yöntem seç',
    ticketSheetLoadErrorGeneric: 'Ödeme yöntemleri yüklenemedi.',
    ticketSheetPriceUnavailable: 'Bu ödeme yöntemi için fiyat yok — başka birini seç.',
    ticketSheetCardConfirmTitle: 'Ödemeyi onayla',
    ticketSheetCardConfirmMessage: 'SHOT BAND girişi için {{card}} kartından {{amount}} çekilsin mi?',
    ticketSheetCardConfirmOk: 'Öde',
    ticketSheetCardPending: 'Click ödemeyi hâlâ onaylıyor — üyelik otomatik açılacak.',
    ticketSheetCardErrorTitle: 'Ödeme geçmedi',
    ticketSheetCardErrorHint: 'Tekrar dene; para kartından çıktıysa desteğe yaz',

    cashbackBalanceLabel: 'Kulüp bakiyesi',
    cashbackCoinsLabel: 'Kıvılcım',
    cashbackTicketsLabel: 'Biletler',
    cashbackNextPayoutLabel: 'Sonraki ödeme:',
    mechanicNameCase: 'Kasalar',
    mechanicNameBattle: 'Savaşlar',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Rulet',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Kontratlar',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: '{{level}}. seviyeden itibaren cashback',
    cashbackSpendButton: 'Harca',
    cashbackInvestButton: 'Yatır',
    cashbackFrozenNote: 'Üyelik bitti — kıvılcımlar ve biletler senin. Kıvılcımları şimdi de alabilirsin; harcamak ve bilet yatırmak için kulüp açık olmalı.',
    cashbackUnlockButton: 'Geri dön',
    cashbackClaimReadyLabel: 'Cashback hazır:',
    cashbackClaimButton: 'Al',
    cashbackTimerLabel: 'kalan:',

    streakDayLabel: '7 günden {{day}}. gün',
    streakHint: 'Art arda {{days}} gün — bonus',

    freeCasesTitle: 'Bedava kasa',
    freeCasesTurnoverLabel: 'Bugünkü ciro',
    freeCasesNextHintPrefix: 'Bedava açmak için',
    freeCasesNextHintSuffix: 'ciro daha',
    freeCasesReadyHint: 'Bedava açabilirsin — al!',
    freeCasesAllClaimed: 'Bugünün tüm bedava açılışları kullanıldı — yenileri sıfırlamadan sonra',
    freeCasesTimerBurnOpen: 'Sıfırlamaya kadar açmazsan yanar',
    freeCasesTimerBurnProgress: 'Ciro ilerlemesinin yanmasına',
    freeCasesTimerPlain: 'Gün sıfırlanmasına',
    freeCasesTimerNew: 'Yeni bedava açılışlara',
    freeCasesOpenFreeButton: 'Aç',
    freeCasesRulesTitle: 'Bedava kasa kuralları',
    freeCasesRulesWagerTitle: 'Coinle oyna',
    freeCasesRulesWagerBody: 'Coinle oynanan her oyun günlük ciroya girer — kasalar, savaşlar, upgrade, kontratlar, Rush Mid, rulet.',
    freeCasesRulesOpenTitle: 'Eşiği geç — bedava aç',
    freeCasesRulesOpenBody: 'Her kasanın kendi ciro eşiği var. Ulaştın mı — açılışı kulüp öder. Her kasa için günde bir bedava açılış.',
    freeCasesRulesResetTitle: 'Gece yarısı her şey yanar',
    freeCasesRulesResetBody: 'Gece yarısı (MSK) gün sıfırlanır: ciro ilerlemesi ve kullanılmayan bedava açılışlar yanar. Yeni gün — sıfırdan.',

    questsTitle: 'Günün görevleri',
    questsResetLabel: 'Yeni görevlere',
    questClaimButton: 'Al',
    questsLockedJoinButton: 'Katıl',
    questGenericTitle: 'Günlük görev',
    questCompletedToastOverline: 'Görev tamamlandı!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Değeri',
    quest_open_3_cases_2500_suffix: 've üzeri olan 3 kasa aç',
    quest_open_3_cases_2500_unit: 'kasa',
    quest_rush_3_matches_prefix: '3 Rush Mid maçı oyna',
    quest_rush_3_matches_unit: 'maç',
    quest_open_band_case_prefix: 'Bir SHOT BAND kasası aç',
    quest_open_band_case_unit: 'kasa',
    quest_wager_25k_prefix: 'Toplam',
    quest_wager_25k_suffix: 'oyna',
    quest_battles_2_5k_prefix: 'Girişi',
    quest_battles_2_5k_suffix: 've üzeri olan 2 kasa savaşı oyna',
    quest_battles_2_5k_unit: 'savaş',
    quest_upgrades_3_2500_prefix: 'Değeri',
    quest_upgrades_3_2500_suffix: 've üzeri olan 3 upgrade yap',
    quest_upgrades_3_2500_unit: 'upgrade',
    quest_contract_10k_prefix: 'Değeri',
    quest_contract_10k_suffix: 've üzeri olan bir kontrat yap',
    quest_contract_10k_unit: 'kontrat',
    quest_win_battle_prefix: 'Bir kasa savaşı kazan',
    quest_win_battle_unit: 'savaş',
    quest_win_upgrade_prefix: 'Bir upgrade kazan',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Değeri',
    quest_open_case_12500_suffix: 've üzeri olan bir kasa aç',
    quest_open_case_12500_unit: 'kasa',
    quest_open_5_cases_1000_prefix: 'Değeri',
    quest_open_5_cases_1000_suffix: 've üzeri olan 5 kasa aç',
    quest_open_5_cases_1000_unit: 'kasa',
    quest_roulette_play_prefix: 'Bir rulet raundu oyna',
    quest_roulette_play_unit: 'raund',
    quest_contracts_25k_sum_prefix: 'Toplam',
    quest_contracts_25k_sum_suffix: 'değerinde kontrat yap',
    quest_upgrades_15k_sum_prefix: 'Toplam',
    quest_upgrades_15k_sum_suffix: 'değerinde upgrade yap',
    quest_rush_5_matches_prefix: '5 Rush Mid maçı oyna',
    quest_rush_5_matches_unit: 'maç',
    quest_wager_50k_prefix: 'Toplam',
    quest_wager_50k_suffix: 'oyna',
    quest_wager_10k_battles_prefix: 'Kasa savaşlarında',
    quest_wager_10k_battles_suffix: 'oyna',
    quest_wager_10k_rush_prefix: "Rush Mid'de",
    quest_wager_10k_rush_suffix: 'oyna',
    quest_wager_10k_roulette_prefix: 'Rulette',
    quest_wager_10k_roulette_suffix: 'oyna',
    quest_wager_100k_prefix: 'Toplam',
    quest_wager_100k_suffix: 'oyna',
    quest_rush_mid_win_prefix: 'Bir Rush Mid maçı kazan',
    quest_rush_mid_win_unit: 'galibiyet',
    quest_big_drop_25k_prefix: 'Kasadan değeri',
    quest_big_drop_25k_suffix: 'üzeri bir eşya düşür',
    quest_big_drop_25k_unit: 'eşya',
    quest_risky_upgrade_35_prefix: 'Şansı %35 ve altı olan bir upgrade kazan',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Kasadan bir Covert eşya düşür',
    quest_covert_drop_unit: 'eşya',

    raceTitle: 'Günün yarışı',
    raceEmpty: 'Bugün yarış yok — daha sonra tekrar bak',
    rulesLinkLabel: 'Kurallar',
    raceRulesTitle: 'Günün yarışı kuralları',
    raceRulesPlayTitle: 'Nasıl kazanılır',
    raceRulesPlayBody: "SHOT'ta ne istersen oyna — kasalar, upgrade, kontratlar, savaşlar, Rush Mid, rulet. Oyunlara harcanan coinler sayılır: günlük cirosu en yüksek olan kazanır.",
    raceRulesPrizeTitle: 'Ödül',
    raceRulesPrizeBody: 'Her gün yeni bir skin. Gece yarısı (MSK) birinciye gider ve doğrudan envanterine düşer.',
    raceRulesMembersTitle: 'Sadece kulübe',
    raceRulesMembersBody: 'Yarış SHOT BAND üyeleri için. Oyunun otomatik sayılır, bir şey açman gerekmez.',
    raffleRulesTitle: 'Haftalık çekiliş kuralları',
    raffleRulesTicketsTitle: 'Bilet kazan',
    raffleRulesTicketsBodyPrefix: 'Günün görevlerini tamamla — karşılığında çekiliş biletleri',
    raffleRulesTicketsBodySuffix: 'verilir.',
    raffleRulesChanceTitle: 'Yatır ve şansını artır',
    raffleRulesChanceBody: 'Biletleri rauna yatır — ne kadar çok yatırırsan şans o kadar yüksek. Yatırılan geri dönmez, üstüne eklemek her zaman serbest.',
    raffleRulesFinalTitle: 'Final',
    raffleRulesFinalBody: 'Raund bir hafta sürer. Kazanan rastgele seçilir, skin doğrudan envantere düşer.',
    racePrizeLabel: 'Günün ödülü',
    raceYourPlace: 'Sıran',
    raceParticipantsLabel: 'Katılan',
    raceNotWagered: 'Bugün herhangi bir oyun oyna — yarıştasın',

    raffleTitle: 'Haftalık çekiliş',
    raffleEmpty: 'Bu hafta çekiliş yok',
    raffleMyInvestedLabel: 'Yatırılan',
    raffleParticipantsLabel: 'Katılan',
    raffleParticipantOne: 'katılımcı',
    raffleParticipantFew: 'katılımcı',
    raffleParticipantMany: 'katılımcı',
    raffleInvestButton: 'Yatır',
    raffleGoToQuestsButton: 'Görevlere git',
    raffleEndedButton: 'Raund bitti',
    raffleWinnersLink: 'Kazananlar',

    investSheetTitle: 'Çekilişe yatır',
    investSheetLockedBody: "Haftalık çekilişe yatırmak için SHOT BAND'e katıl.",
    investSheetJoinButton: 'Katıl',
    investSheetEndedBody: 'Bu raund çoktan bitti — bir sonrakini bekle.',
    investSheetNoBalanceBody: 'Henüz yatıracak bir şey yok — kazanmak için günün görevlerini tamamla.',
    investSheetDecrease: 'Azalt',
    investSheetIncrease: 'Artır',
    investSheetBalanceHint: 'Kullanılabilir: {{balance}}',
    investSheetDisclaimer: 'Yatırılan geri dönmez — istediğin zaman üstüne ekleyebilirsin.',
    investSheetErrorGeneric: 'Yatırılamadı. Tekrar dene.',
    investSheetSubmitButton: 'Yatır',
  },
  uk: {
    title: 'SHOT BAND',
    loading: 'Завантаження SHOT BAND...',
    heroWelcome: 'Ласкаво просимо до',
    heroMemberBadge: 'Ти в SHOT BAND',
    heroDaysLeftOne: 'Залишився {{count}} день',
    heroDaysLeftFew: 'Залишилось {{count}} дні',
    heroDaysLeftMany: 'Залишилось {{count}} днів',
    heroDaysLeftZero: 'Членство закінчується сьогодні',
    heroRenewButton: 'Продовжити',
    heroOfferTitlePrefix: 'Поповнення на',
    heroOfferTitleSuffix: 'вмикає клуб — тут або в звичайному поповненні.',
    heroOfferBody: 'Кешбек до 4% — росте з рівнем, щоденні завдання і шанс виграти ніж у розіграші.',
    heroOfferFinePrint:
      'Уся сума зарахується на твій ігровий баланс. Витрачай її на кейси, контракти, ігри й апгрейди як захочеш.',
    heroJoinButton: 'Вступити за',
    heroHowItWorks: 'Як це працює',
    rulesTitle: 'Як працює SHOT BAND',
    rule1Prefix: 'Закинь ',
    rule1Suffix: ' одним платежем — ти в SHOT BAND на 28 днів. Монети прийдуть на твій баланс, як зазвичай.',
    rule1Title: 'Вхід у SHOT BAND',
    rule2Title: 'Кешбек до 4%',
    rule2:
      'Кожна гра за монети повертає кешбек іскрами. Відсоток росте з рівнем — 1% на 10-му, 4% на 100-му. Забирай кожні 7 днів.',
    rule3Title: 'Кейси за іскри',
    rule3Prefix: 'Іскри ',
    rule3Suffix: ' відкривають кейси SHOT BAND — усередині скіни аж до ножів.',
    rule4Title: 'Завдання і серія',
    rule4Prefix: 'Щоденні завдання приносять ',
    rule4Mid: '. Тримай серію 7 днів — отримаєш +10 ',
    rule4Suffix: ' бонусом.',
    rule5Title: 'Розіграш ножа',
    rule5Prefix: 'Щотижня розігруємо ніж. Вкладай ',
    rule5Suffix: ' — що більше квитків, то вищий шанс.',
    rule6Title: 'Гонка дня',
    rule6: 'Зіграй за монети більше за всіх до опівночі за Москвою — і скін дня твій. Щодня новий приз.',
    rule7Title: 'Безкоштовні кейси за оборот',
    rule7:
      'Денний оборот відкриває кейси полиці безкоштовно — що більше граєш, то дорожчий фрі-кейс. Хоч усі кейси, хоч щодня.',
    ticketSheetTitleJoin: 'Вступ до SHOT BAND',
    ticketSheetTitleRenew: 'Продовження SHOT BAND',
    ticketSheetTopupNotePrefix: 'На баланс одразу зарахується',
    ticketSheetTopupNoteSuffix: '— клуб іде подарунком.',
    ticketSheetRenewDisclaimer: 'Продовження додасться до поточного терміну членства — плюс 28 днів.',
    ticketSheetRenewTooEarly: 'Продовження відкриється за добу до кінця членства — зазирни ближче до цього терміну.',
    ticketSheetBuyButton: 'Сплатити',
    ticketSheetLoadingProviders: 'Завантажуємо способи оплати...',
    ticketSheetNoProviders: 'Зараз немає доступних способів оплати.',
    ticketSheetErrorTitle: 'Не вдалося створити рахунок',
    ticketSheetErrorHint: 'Спробуй ще раз або обери інший спосіб',
    ticketSheetLoadErrorGeneric: 'Не вдалося завантажити способи оплати.',
    ticketSheetPriceUnavailable: 'Ціна недоступна для цього способу — обери інший.',
    ticketSheetCardConfirmTitle: 'Підтверди оплату',
    ticketSheetCardConfirmMessage: 'Списати {{amount}} з картки {{card}} за вступ до SHOT BAND?',
    ticketSheetCardConfirmOk: 'Сплатити',
    ticketSheetCardPending: 'Click ще підтверджує платіж — членство ввімкнеться автоматично.',
    ticketSheetCardErrorTitle: 'Оплата не пройшла',
    ticketSheetCardErrorHint: 'Спробуй ще раз; якщо гроші зійшли з картки, напиши в підтримку',
    cashbackBalanceLabel: 'Баланс клубу',
    cashbackCoinsLabel: 'Іскри',
    cashbackTicketsLabel: 'Квитки',
    cashbackNextPayoutLabel: 'Наступна виплата:',
    mechanicNameCase: 'Кейси',
    mechanicNameBattle: 'Кейс-батли',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Рулетка',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Контракти',
    cashbackChipPrefix: 'кешбек',
    cashbackChipLocked: 'кешбек з {{level}} рівня',
    cashbackSpendButton: 'Витратити',
    cashbackInvestButton: 'Вкласти',
    cashbackFrozenNote:
      'Членство закінчилось — іскри й квитки залишились твоїми. Забрати іскри можна й зараз, а витрачати їх і вкладати квитки — лише в клубі.',
    cashbackUnlockButton: 'Повернутися',
    cashbackClaimReadyLabel: 'Кешбек готовий:',
    cashbackClaimButton: 'Забрати',
    cashbackTimerLabel: 'через',
    streakDayLabel: 'День {{day}} із 7',
    streakHint: '{{days}} днів поспіль — бонус',
    freeCasesTitle: 'Безкоштовний кейс',
    freeCasesTurnoverLabel: 'Оборот сьогодні',
    freeCasesNextHintPrefix: 'Ще',
    freeCasesNextHintSuffix: 'обороту — і відкриєш його безкоштовно',
    freeCasesReadyHint: 'Можна відкрити безкоштовно — забирай!',
    freeCasesAllClaimed: 'Усе безкоштовне на сьогодні відкрито — нове після скидання',
    freeCasesTimerBurnOpen: 'Не відкриєш до скидання — згорить',
    freeCasesTimerBurnProgress: 'Прогрес обороту згорить через',
    freeCasesTimerPlain: 'До скидання дня',
    freeCasesTimerNew: 'Нові безкоштовні відкриття через',
    freeCasesOpenFreeButton: 'Відкрити',
    freeCasesRulesTitle: 'Правила безкоштовного кейса',
    freeCasesRulesWagerTitle: 'Грай за монети',
    freeCasesRulesWagerBody:
      'Будь-яка гра за монети йде в денний оборот — кейси, батли, апгрейди, контракти, Rush Mid, рулетка.',
    freeCasesRulesOpenTitle: 'Досяг порогу — відкриваєш безкоштовно',
    freeCasesRulesOpenBody:
      'У кожного кейса свій поріг обороту. Дійшов до нього — клуб платить за відкриття. Одне безкоштовне відкриття кейса на день.',
    freeCasesRulesResetTitle: 'Опівночі все згорає',
    freeCasesRulesResetBody:
      'Опівночі за Москвою день обнуляється: прогрес обороту й невзяті безкоштовні відкриття згорають. Новий день — з нуля.',
    questsTitle: 'Завдання дня',
    questsResetLabel: 'Нові завдання через',
    questClaimButton: 'Забрати',
    questsLockedJoinButton: 'Вступити',
    questGenericTitle: 'Щоденне завдання',
    questCompletedToastOverline: 'Завдання виконано!',
    questGenericUnit: '',
    quest_open_3_cases_2500_prefix: 'Відкрий 3 кейси від',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'кейси',
    quest_rush_3_matches_prefix: 'Зіграй 3 матчі в Rush Mid',
    quest_rush_3_matches_unit: 'матчі',
    quest_open_band_case_prefix: 'Відкрий кейс SHOT BAND',
    quest_open_band_case_unit: 'кейс',
    quest_wager_25k_prefix: 'Зіграй на',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Зіграй 2 батли вартістю від',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'батли',
    quest_upgrades_3_2500_prefix: 'Зроби 3 апгрейди від',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'апгрейди',
    quest_contract_10k_prefix: 'Збери контракт від',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'контракт',
    quest_win_battle_prefix: 'Виграй батл',
    quest_win_battle_unit: 'батл',
    quest_win_upgrade_prefix: 'Виграй апгрейд',
    quest_win_upgrade_unit: 'апгрейд',
    quest_open_case_12500_prefix: 'Відкрий кейс від',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'кейс',
    quest_open_5_cases_1000_prefix: 'Відкрий 5 кейсів від',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'кейсів',
    quest_roulette_play_prefix: 'Зіграй раунд рулетки',
    quest_roulette_play_unit: 'раунд',
    quest_contracts_25k_sum_prefix: 'Збери контрактів на',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Зроби апгрейдів на',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Зіграй 5 матчів Rush Mid',
    quest_rush_5_matches_unit: 'матчів',
    quest_wager_50k_prefix: 'Зіграй на',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Зіграй на',
    quest_wager_10k_battles_suffix: 'у батлах',
    quest_wager_10k_rush_prefix: 'Зіграй на',
    quest_wager_10k_rush_suffix: 'у Rush Mid',
    quest_wager_10k_roulette_prefix: 'Зіграй на',
    quest_wager_10k_roulette_suffix: 'у рулетці',
    quest_wager_100k_prefix: 'Зіграй на',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Переможи в Rush Mid',
    quest_rush_mid_win_unit: 'перемога',
    quest_big_drop_25k_prefix: 'Вибий предмет дорожче',
    quest_big_drop_25k_suffix: 'з кейса',
    quest_big_drop_25k_unit: 'предмет',
    quest_risky_upgrade_35_prefix: 'Виграй апгрейд із шансом до 35%',
    quest_risky_upgrade_35_unit: 'апгрейд',
    quest_covert_drop_prefix: 'Вибий предмет Covert з кейса',
    quest_covert_drop_unit: 'предмет',
    raceTitle: 'Гонка дня',
    raceEmpty: 'Сьогодні гонки немає — зазирни пізніше',
    rulesLinkLabel: 'Правила',
    raceRulesTitle: 'Правила гонки дня',
    raceRulesPlayTitle: 'Як перемогти',
    raceRulesPlayBody:
      'Грай у що завгодно в SHOT — кейси, апгрейди, контракти, батли, Rush Mid, рулетку. Рахуються витрачені на ігри монети: у кого денний оборот найбільший — той і переміг.',
    raceRulesPrizeTitle: 'Приз',
    raceRulesPrizeBody: 'Щодня — новий скін. Опівночі за Москвою він іде першому місцю й одразу падає в інвентар.',
    raceRulesMembersTitle: 'Лише для клубу',
    raceRulesMembersBody: 'Гонка — для членів SHOT BAND. Гра зараховується автоматично, нічого вмикати не треба.',
    raffleRulesTitle: 'Правила розіграшу тижня',
    raffleRulesTicketsTitle: 'Отримуй квитки',
    raffleRulesTicketsBodyPrefix: 'Виконуй завдання дня — за них дають квитки',
    raffleRulesTicketsBodySuffix: 'розіграшу.',
    raffleRulesChanceTitle: 'Вкладай і підвищуй шанс',
    raffleRulesChanceBody:
      'Вкладай квитки в раунд — що більше вклав, то вищий шанс. Вкладене не повертається, докидати можна завжди.',
    raffleRulesFinalTitle: 'Фінал',
    raffleRulesFinalBody: 'Раунд іде тиждень. Переможця обирає випадковість, скін одразу падає в інвентар.',
    racePrizeLabel: 'Приз дня',
    raceYourPlace: 'Твоє місце',
    raceParticipantsLabel: 'Бере участь',
    raceNotWagered: 'Зіграй сьогодні в будь-яку гру — і ти в гонці',
    raffleTitle: 'Розіграш тижня',
    raffleEmpty: 'Цього тижня розіграшу немає',
    raffleMyInvestedLabel: 'Вкладено',
    raffleParticipantsLabel: 'Бере участь',
    raffleParticipantOne: 'учасник',
    raffleParticipantFew: 'учасники',
    raffleParticipantMany: 'учасників',
    raffleInvestButton: 'Вкласти',
    raffleGoToQuestsButton: 'До завдань',
    raffleEndedButton: 'Раунд завершено',
    raffleWinnersLink: 'Переможці',
    investSheetTitle: 'Вкласти в розіграш',
    investSheetLockedBody: 'Вступи в SHOT BAND, щоб вкладати в щотижневий розіграш.',
    investSheetJoinButton: 'Вступити',
    investSheetEndedBody: 'Цей раунд уже завершено — дочекайся наступного.',
    investSheetNoBalanceBody: 'Поки нічого вкладати — виконуй завдання дня, щоб отримати.',
    investSheetDecrease: 'Зменшити',
    investSheetIncrease: 'Збільшити',
    investSheetBalanceHint: 'Доступно: {{balance}}',
    investSheetDisclaimer: 'Вкладене не повертається — докинути можна будь-коли.',
    investSheetErrorGeneric: 'Не вдалося вкласти. Спробуй ще раз.',
    investSheetSubmitButton: 'Вкласти',
  },
  de: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND wird geladen...',
    heroWelcome: 'Willkommen bei',
    heroMemberBadge: 'Du bist in SHOT BAND',
    heroDaysLeftOne: 'Noch {{count}} Tag',
    heroDaysLeftFew: 'Noch {{count}} Tage',
    heroDaysLeftMany: 'Noch {{count}} Tage',
    heroDaysLeftZero: 'Die Mitgliedschaft endet heute',
    heroRenewButton: 'Verlängern',
    heroOfferTitlePrefix: 'Eine Aufladung von',
    heroOfferTitleSuffix: 'schaltet den Club frei – hier oder bei einer normalen Aufladung.',
    heroOfferBody:
      'Cashback bis 4 % – wächst mit deinem Level –, tägliche Aufgaben und die Chance auf ein Messer in der Verlosung.',
    heroOfferFinePrint:
      'Der gesamte Betrag landet auf deinem Spielguthaben. Gib ihn für Cases, Contracts, Spiele und Upgrades aus, wie du willst.',
    heroJoinButton: 'Beitreten für',
    heroHowItWorks: 'So funktioniert’s',
    rulesTitle: 'So funktioniert SHOT BAND',
    rule1Prefix: 'Zahle ',
    rule1Suffix:
      ' in einer Zahlung ein – und du bist 28 Tage in SHOT BAND. Die Münzen landen wie gewohnt auf deinem Guthaben.',
    rule1Title: 'Beitritt zu SHOT BAND',
    rule2Title: 'Cashback bis 4 %',
    rule2:
      'Jedes Spiel mit Münzen zahlt Cashback in Funken zurück. Der Satz wächst mit deinem Level – 1 % auf Level 10, 4 % auf Level 100. Hol ihn alle 7 Tage ab.',
    rule3Title: 'Cases für Funken',
    rule3Prefix: 'Funken ',
    rule3Suffix: ' öffnen SHOT-BAND-Cases – darin stecken Skins bis hin zu Messern.',
    rule4Title: 'Aufgaben und Serie',
    rule4Prefix: 'Tägliche Aufgaben bringen ',
    rule4Mid: '. Halte die Serie 7 Tage – dann gibt es +10 ',
    rule4Suffix: ' als Bonus.',
    rule5Title: 'Messer-Verlosung',
    rule5Prefix: 'Jede Woche verlosen wir ein Messer. Investiere ',
    rule5Suffix: ' – je mehr Tickets, desto höher die Chance.',
    rule6Title: 'Tagesrennen',
    rule6:
      'Spiele bis Mitternacht (MSK) mit Münzen am meisten und sichere dir den Skin des Tages. Jeden Tag ein neuer Preis.',
    rule7Title: 'Gratis-Cases für Umsatz',
    rule7:
      'Dein Tagesumsatz öffnet Regal-Cases gratis – je mehr du spielst, desto wertvoller die Gratis-Case. Bis zu jeder Case, jeden Tag.',
    ticketSheetTitleJoin: 'SHOT BAND beitreten',
    ticketSheetTitleRenew: 'SHOT BAND verlängern',
    ticketSheetTopupNotePrefix: 'Deinem Guthaben werden sofort gutgeschrieben',
    ticketSheetTopupNoteSuffix: '– der Club kommt als Geschenk dazu.',
    ticketSheetRenewDisclaimer: 'Die Verlängerung wird zu deiner aktuellen Laufzeit addiert – plus 28 Tage.',
    ticketSheetRenewTooEarly:
      'Die Verlängerung öffnet einen Tag vor Ablauf der Mitgliedschaft – schau kurz vorher wieder rein.',
    ticketSheetBuyButton: 'Bezahlen',
    ticketSheetLoadingProviders: 'Zahlungsarten werden geladen...',
    ticketSheetNoProviders: 'Gerade sind keine Zahlungsarten verfügbar.',
    ticketSheetErrorTitle: 'Rechnung konnte nicht erstellt werden',
    ticketSheetErrorHint: 'Versuch es nochmal oder wähle eine andere Zahlungsart',
    ticketSheetLoadErrorGeneric: 'Zahlungsarten konnten nicht geladen werden.',
    ticketSheetPriceUnavailable: 'Für diese Zahlungsart ist kein Preis verfügbar – wähle eine andere.',
    ticketSheetCardConfirmTitle: 'Zahlung bestätigen',
    ticketSheetCardConfirmMessage: '{{amount}} von {{card}} abbuchen, um SHOT BAND beizutreten?',
    ticketSheetCardConfirmOk: 'Bezahlen',
    ticketSheetCardPending: 'Click bestätigt die Zahlung noch – die Mitgliedschaft wird automatisch aktiviert.',
    ticketSheetCardErrorTitle: 'Zahlung fehlgeschlagen',
    ticketSheetCardErrorHint: 'Versuch es nochmal; falls das Geld abgebucht wurde, wende dich an den Support',
    cashbackBalanceLabel: 'Club-Guthaben',
    cashbackCoinsLabel: 'Funken',
    cashbackTicketsLabel: 'Tickets',
    cashbackNextPayoutLabel: 'Nächste Auszahlung:',
    mechanicNameCase: 'Cases',
    mechanicNameBattle: 'Case Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roulette',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Contracts',
    cashbackChipPrefix: 'Cashback',
    cashbackChipLocked: 'Cashback ab Level {{level}}',
    cashbackSpendButton: 'Ausgeben',
    cashbackInvestButton: 'Investieren',
    cashbackFrozenNote:
      'Deine Mitgliedschaft ist abgelaufen – Funken und Tickets bleiben dir. Funken kannst du weiter abholen; sie ausgeben und Tickets investieren geht nur im Club.',
    cashbackUnlockButton: 'Zurückkehren',
    cashbackClaimReadyLabel: 'Cashback bereit:',
    cashbackClaimButton: 'Abholen',
    cashbackTimerLabel: 'in',
    streakDayLabel: 'Tag {{day}} von 7',
    streakHint: '{{days}} Tage in Folge – Bonus',
    freeCasesTitle: 'Gratis-Case',
    freeCasesTurnoverLabel: 'Umsatz heute',
    freeCasesNextHintPrefix: 'Noch',
    freeCasesNextHintSuffix: 'Umsatz, und du öffnest sie gratis',
    freeCasesReadyHint: 'Gratis öffnen – schnapp sie dir!',
    freeCasesAllClaimed: 'Alle Gratis-Öffnungen für heute sind verbraucht – neue nach dem Reset',
    freeCasesTimerBurnOpen: 'Wenn du bis zum Reset nicht öffnest, verfällt sie',
    freeCasesTimerBurnProgress: 'Der Umsatzfortschritt verfällt in',
    freeCasesTimerPlain: 'Bis zum Tages-Reset',
    freeCasesTimerNew: 'Neue Gratis-Öffnungen in',
    freeCasesOpenFreeButton: 'Öffnen',
    freeCasesRulesTitle: 'Regeln der Gratis-Case',
    freeCasesRulesWagerTitle: 'Spiele mit Münzen',
    freeCasesRulesWagerBody:
      'Jedes Spiel mit Münzen zählt zum Tagesumsatz – Cases, Battles, Upgrades, Contracts, Rush Mid, Roulette.',
    freeCasesRulesOpenTitle: 'Schwelle erreicht – gratis öffnen',
    freeCasesRulesOpenBody:
      'Jede Case hat ihre eigene Umsatzschwelle. Hast du sie erreicht, zahlt der Club die Öffnung. Eine Gratis-Öffnung pro Case und Tag.',
    freeCasesRulesResetTitle: 'Um Mitternacht verfällt alles',
    freeCasesRulesResetBody:
      'Um Mitternacht (MSK) wird der Tag zurückgesetzt: Umsatzfortschritt und nicht genutzte Gratis-Öffnungen verfallen. Der neue Tag beginnt bei null.',
    questsTitle: 'Tagesaufgaben',
    questsResetLabel: 'Neue Aufgaben in',
    questClaimButton: 'Abholen',
    questsLockedJoinButton: 'Beitreten',
    questGenericTitle: 'Tagesaufgabe',
    questCompletedToastOverline: 'Aufgabe erledigt!',
    questGenericUnit: '',
    quest_open_3_cases_2500_prefix: 'Öffne 3 Cases ab',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'Cases',
    quest_rush_3_matches_prefix: 'Spiele 3 Rush-Mid-Matches',
    quest_rush_3_matches_unit: 'Matches',
    quest_open_band_case_prefix: 'Öffne eine SHOT-BAND-Case',
    quest_open_band_case_unit: 'Case',
    quest_wager_25k_prefix: 'Spiele für',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Spiele 2 Case Battles mit einem Eintritt ab',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'Battles',
    quest_upgrades_3_2500_prefix: 'Mach 3 Upgrades ab',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'Upgrades',
    quest_contract_10k_prefix: 'Schließe einen Contract ab',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'Contract',
    quest_win_battle_prefix: 'Gewinne ein Case Battle',
    quest_win_battle_unit: 'Battle',
    quest_win_upgrade_prefix: 'Gewinne ein Upgrade',
    quest_win_upgrade_unit: 'Upgrade',
    quest_open_case_12500_prefix: 'Öffne eine Case ab',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'Case',
    quest_open_5_cases_1000_prefix: 'Öffne 5 Cases ab',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'Cases',
    quest_roulette_play_prefix: 'Spiele eine Roulette-Runde',
    quest_roulette_play_unit: 'Runde',
    quest_contracts_25k_sum_prefix: 'Contracts im Gesamtwert von',
    quest_contracts_25k_sum_suffix: 'abschließen',
    quest_upgrades_15k_sum_prefix: 'Upgrades im Gesamtwert von',
    quest_upgrades_15k_sum_suffix: 'durchführen',
    quest_rush_5_matches_prefix: 'Spiele 5 Rush-Mid-Matches',
    quest_rush_5_matches_unit: 'Matches',
    quest_wager_50k_prefix: 'Spiele für',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Spiele für',
    quest_wager_10k_battles_suffix: 'in Case Battles',
    quest_wager_10k_rush_prefix: 'Spiele für',
    quest_wager_10k_rush_suffix: 'in Rush Mid',
    quest_wager_10k_roulette_prefix: 'Spiele für',
    quest_wager_10k_roulette_suffix: 'in Roulette',
    quest_wager_100k_prefix: 'Spiele für',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Gewinne ein Rush-Mid-Match',
    quest_rush_mid_win_unit: 'Sieg',
    quest_big_drop_25k_prefix: 'Erziele einen Drop über',
    quest_big_drop_25k_suffix: 'aus einer Case',
    quest_big_drop_25k_unit: 'Item',
    quest_risky_upgrade_35_prefix: 'Gewinne ein Upgrade mit einer Chance von höchstens 35 %',
    quest_risky_upgrade_35_unit: 'Upgrade',
    quest_covert_drop_prefix: 'Erziele einen Covert-Drop aus einer Case',
    quest_covert_drop_unit: 'Item',
    raceTitle: 'Tagesrennen',
    raceEmpty: 'Heute gibt es kein Rennen – schau später wieder vorbei',
    rulesLinkLabel: 'Regeln',
    raceRulesTitle: 'Regeln des Tagesrennens',
    raceRulesPlayTitle: 'So gewinnst du',
    raceRulesPlayBody:
      'Spiele auf SHOT, was du willst – Cases, Upgrades, Contracts, Battles, Rush Mid, Roulette. Es zählen die Münzen, die du in Spielen ausgibst: Wer am Tag den höchsten Umsatz hat, gewinnt.',
    raceRulesPrizeTitle: 'Der Preis',
    raceRulesPrizeBody:
      'Jeden Tag ein neuer Skin. Um Mitternacht (MSK) geht er an Platz 1 und landet sofort im Inventar.',
    raceRulesMembersTitle: 'Nur für Mitglieder',
    raceRulesMembersBody:
      'Das Rennen ist für SHOT-BAND-Mitglieder. Dein Spiel zählt automatisch – du musst nichts aktivieren.',
    raffleRulesTitle: 'Regeln der Wochenverlosung',
    raffleRulesTicketsTitle: 'Sammle Tickets',
    raffleRulesTicketsBodyPrefix: 'Erledige Tagesaufgaben – dafür gibt es Tickets',
    raffleRulesTicketsBodySuffix: 'für die Verlosung.',
    raffleRulesChanceTitle: 'Investiere und erhöhe deine Chance',
    raffleRulesChanceBody:
      'Investiere Tickets in die Runde – je mehr du investierst, desto höher deine Chance. Investierte Tickets kommen nicht zurück, nachlegen geht immer.',
    raffleRulesFinalTitle: 'Das Finale',
    raffleRulesFinalBody:
      'Die Runde dauert eine Woche. Der Gewinner wird zufällig gezogen, der Skin landet sofort im Inventar.',
    racePrizeLabel: 'Tagespreis',
    raceYourPlace: 'Dein Platz',
    raceParticipantsLabel: 'Dabei',
    raceNotWagered: 'Spiel heute irgendetwas und du bist im Rennen',
    raffleTitle: 'Wochenverlosung',
    raffleEmpty: 'Diese Woche läuft keine Verlosung',
    raffleMyInvestedLabel: 'Investiert',
    raffleParticipantsLabel: 'Dabei',
    raffleParticipantOne: 'Teilnehmer',
    raffleParticipantFew: 'Teilnehmer',
    raffleParticipantMany: 'Teilnehmer',
    raffleInvestButton: 'Investieren',
    raffleGoToQuestsButton: 'Zu den Aufgaben',
    raffleEndedButton: 'Runde beendet',
    raffleWinnersLink: 'Gewinner',
    investSheetTitle: 'In die Verlosung investieren',
    investSheetLockedBody: 'Tritt SHOT BAND bei, um in die Wochenverlosung zu investieren.',
    investSheetJoinButton: 'Beitreten',
    investSheetEndedBody: 'Diese Runde ist bereits vorbei – warte auf die nächste.',
    investSheetNoBalanceBody: 'Noch nichts zum Investieren – erledige Tagesaufgaben, um welche zu bekommen.',
    investSheetDecrease: 'Verringern',
    investSheetIncrease: 'Erhöhen',
    investSheetBalanceHint: 'Verfügbar: {{balance}}',
    investSheetDisclaimer: 'Investiertes kommt nicht zurück – nachlegen kannst du jederzeit.',
    investSheetErrorGeneric: 'Investieren fehlgeschlagen. Versuch es nochmal.',
    investSheetSubmitButton: 'Investieren',
  },
  es: {
    title: 'SHOT BAND',
    loading: 'Cargando SHOT BAND...',
    heroWelcome: 'Bienvenido a',
    heroMemberBadge: 'Estás en SHOT BAND',
    heroDaysLeftOne: 'Queda {{count}} día',
    heroDaysLeftFew: 'Quedan {{count}} días',
    heroDaysLeftMany: 'Quedan {{count}} días',
    heroDaysLeftZero: 'La membresía termina hoy',
    heroRenewButton: 'Renovar',
    heroOfferTitlePrefix: 'Una recarga de',
    heroOfferTitleSuffix: 'activa el club, aquí o en una recarga normal.',
    heroOfferBody:
      'Cashback de hasta el 4 %, que crece con tu nivel, misiones diarias y la opción de ganar un cuchillo en el sorteo.',
    heroOfferFinePrint:
      'Todo el importe se abona a tu saldo de juego. Puedes gastarlo en cajas, contratos, juegos y upgrades como quieras.',
    heroJoinButton: 'Unirse por',
    heroHowItWorks: 'Cómo funciona',
    rulesTitle: 'Cómo funciona SHOT BAND',
    rule1Prefix: 'Recarga ',
    rule1Suffix: ' en un solo pago y estarás en SHOT BAND durante 28 días. Las monedas llegan a tu saldo como siempre.',
    rule1Title: 'Entrar en SHOT BAND',
    rule2Title: 'Cashback de hasta el 4 %',
    rule2:
      'Cada juego con monedas devuelve cashback en chispas. El porcentaje crece con tu nivel: 1 % en el nivel 10 y 4 % en el 100. Recógelo cada 7 días.',
    rule3Title: 'Cajas por chispas',
    rule3Prefix: 'Las chispas ',
    rule3Suffix: ' abren las cajas de SHOT BAND: dentro hay skins hasta cuchillos.',
    rule4Title: 'Misiones y racha',
    rule4Prefix: 'Las misiones diarias dan ',
    rule4Mid: '. Mantén una racha de 7 días y recibirás +10 ',
    rule4Suffix: ' de bonus.',
    rule5Title: 'Sorteo del cuchillo',
    rule5Prefix: 'Cada semana sorteamos un cuchillo. Invierte ',
    rule5Suffix: ' : cuantos más tickets, más posibilidades.',
    rule6Title: 'Carrera del día',
    rule6:
      'Juega más que nadie con monedas antes de medianoche (hora de Moscú) y el skin del día es tuyo. Cada día, un premio nuevo.',
    rule7Title: 'Cajas gratis por volumen de juego',
    rule7:
      'Tu volumen de juego diario abre cajas de la estantería gratis: cuanto más juegas, más valiosa es la caja gratis. Hasta todas las cajas, todos los días.',
    ticketSheetTitleJoin: 'Unirse a SHOT BAND',
    ticketSheetTitleRenew: 'Renovar SHOT BAND',
    ticketSheetTopupNotePrefix: 'Se abonan de inmediato a tu saldo',
    ticketSheetTopupNoteSuffix: ': el club va de regalo.',
    ticketSheetRenewDisclaimer: 'La renovación se suma a tu periodo actual de membresía: 28 días más.',
    ticketSheetRenewTooEarly:
      'La renovación se abre un día antes de que termine la membresía: vuelve más cerca de esa fecha.',
    ticketSheetBuyButton: 'Pagar',
    ticketSheetLoadingProviders: 'Cargando métodos de pago...',
    ticketSheetNoProviders: 'Ahora mismo no hay métodos de pago disponibles.',
    ticketSheetErrorTitle: 'No se pudo crear la factura',
    ticketSheetErrorHint: 'Inténtalo de nuevo o elige otro método',
    ticketSheetLoadErrorGeneric: 'No se pudieron cargar los métodos de pago.',
    ticketSheetPriceUnavailable: 'El precio no está disponible para este método: elige otro.',
    ticketSheetCardConfirmTitle: 'Confirma el pago',
    ticketSheetCardConfirmMessage: '¿Cobrar {{amount}} de la tarjeta {{card}} para unirte a SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pagar',
    ticketSheetCardPending: 'Click todavía está confirmando el pago: la membresía se activará automáticamente.',
    ticketSheetCardErrorTitle: 'El pago no se realizó',
    ticketSheetCardErrorHint: 'Inténtalo de nuevo; si el dinero salió de tu tarjeta, escribe a soporte',
    cashbackBalanceLabel: 'Saldo del club',
    cashbackCoinsLabel: 'Chispas',
    cashbackTicketsLabel: 'Tickets',
    cashbackNextPayoutLabel: 'Próximo pago:',
    mechanicNameCase: 'Cajas',
    mechanicNameBattle: 'Case Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Ruleta',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Contratos',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback desde el nivel {{level}}',
    cashbackSpendButton: 'Gastar',
    cashbackInvestButton: 'Invertir',
    cashbackFrozenNote:
      'Tu membresía terminó: las chispas y los tickets siguen siendo tuyos. Aún puedes recoger chispas, pero gastarlas e invertir tickets solo es posible dentro del club.',
    cashbackUnlockButton: 'Volver',
    cashbackClaimReadyLabel: 'Cashback listo:',
    cashbackClaimButton: 'Recoger',
    cashbackTimerLabel: 'en',
    streakDayLabel: 'Día {{day}} de 7',
    streakHint: '{{days}} días seguidos: bonus',
    freeCasesTitle: 'Caja gratis',
    freeCasesTurnoverLabel: 'Volumen de hoy',
    freeCasesNextHintPrefix: 'Juega',
    freeCasesNextHintSuffix: 'más y la abres gratis',
    freeCasesReadyHint: 'Se puede abrir gratis: ¡recógela!',
    freeCasesAllClaimed: 'Ya usaste todas las aperturas gratis de hoy: habrá nuevas tras el reinicio',
    freeCasesTimerBurnOpen: 'Si no la abres antes del reinicio, se pierde',
    freeCasesTimerBurnProgress: 'El progreso del volumen se pierde en',
    freeCasesTimerPlain: 'Hasta el reinicio del día',
    freeCasesTimerNew: 'Nuevas aperturas gratis en',
    freeCasesOpenFreeButton: 'Abrir',
    freeCasesRulesTitle: 'Reglas de la caja gratis',
    freeCasesRulesWagerTitle: 'Juega con monedas',
    freeCasesRulesWagerBody:
      'Cualquier juego con monedas cuenta para tu volumen diario: cajas, battles, upgrades, contratos, Rush Mid y ruleta.',
    freeCasesRulesOpenTitle: 'Alcanzas el umbral: abres gratis',
    freeCasesRulesOpenBody:
      'Cada caja tiene su propio umbral de volumen. Si lo alcanzas, el club paga la apertura. Una apertura gratis por caja al día.',
    freeCasesRulesResetTitle: 'A medianoche todo se pierde',
    freeCasesRulesResetBody:
      'A medianoche (hora de Moscú) el día se reinicia: el progreso del volumen y las aperturas gratis sin usar se pierden. El nuevo día empieza de cero.',
    questsTitle: 'Misiones del día',
    questsResetLabel: 'Nuevas misiones en',
    questClaimButton: 'Recoger',
    questsLockedJoinButton: 'Unirse',
    questGenericTitle: 'Misión diaria',
    questCompletedToastOverline: '¡Misión cumplida!',
    questGenericUnit: '',
    quest_open_3_cases_2500_prefix: 'Abre 3 cajas desde',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'cajas',
    quest_rush_3_matches_prefix: 'Juega 3 partidas de Rush Mid',
    quest_rush_3_matches_unit: 'partidas',
    quest_open_band_case_prefix: 'Abre una caja de SHOT BAND',
    quest_open_band_case_unit: 'caja',
    quest_wager_25k_prefix: 'Juega por',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Juega 2 Case Battles con una entrada desde',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'battles',
    quest_upgrades_3_2500_prefix: 'Haz 3 upgrades desde',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Completa un contrato desde',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'contrato',
    quest_win_battle_prefix: 'Gana un Case Battle',
    quest_win_battle_unit: 'battle',
    quest_win_upgrade_prefix: 'Gana un upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Abre una caja desde',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'caja',
    quest_open_5_cases_1000_prefix: 'Abre 5 cajas desde',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'cajas',
    quest_roulette_play_prefix: 'Juega una ronda de ruleta',
    quest_roulette_play_unit: 'ronda',
    quest_contracts_25k_sum_prefix: 'Completa contratos por un total de',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Haz upgrades por un total de',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Juega 5 partidas de Rush Mid',
    quest_rush_5_matches_unit: 'partidas',
    quest_wager_50k_prefix: 'Juega por',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Juega por',
    quest_wager_10k_battles_suffix: 'en Case Battles',
    quest_wager_10k_rush_prefix: 'Juega por',
    quest_wager_10k_rush_suffix: 'en Rush Mid',
    quest_wager_10k_roulette_prefix: 'Juega por',
    quest_wager_10k_roulette_suffix: 'en la ruleta',
    quest_wager_100k_prefix: 'Juega por',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Gana una partida de Rush Mid',
    quest_rush_mid_win_unit: 'victoria',
    quest_big_drop_25k_prefix: 'Consigue un objeto de más de',
    quest_big_drop_25k_suffix: 'de una caja',
    quest_big_drop_25k_unit: 'objeto',
    quest_risky_upgrade_35_prefix: 'Gana un upgrade con una probabilidad del 35 % o menos',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Consigue un objeto Covert de una caja',
    quest_covert_drop_unit: 'objeto',
    raceTitle: 'Carrera del día',
    raceEmpty: 'Hoy no hay carrera: vuelve más tarde',
    rulesLinkLabel: 'Reglas',
    raceRulesTitle: 'Reglas de la carrera del día',
    raceRulesPlayTitle: 'Cómo ganar',
    raceRulesPlayBody:
      'Juega a lo que quieras en SHOT: cajas, upgrades, contratos, battles, Rush Mid, ruleta. Cuentan las monedas gastadas en juegos: gana quien tenga el mayor volumen del día.',
    raceRulesPrizeTitle: 'El premio',
    raceRulesPrizeBody:
      'Cada día, un skin nuevo. A medianoche (hora de Moscú) pasa al primer puesto y llega directo al inventario.',
    raceRulesMembersTitle: 'Solo para miembros',
    raceRulesMembersBody:
      'La carrera es para miembros de SHOT BAND. Tu juego cuenta automáticamente: no hay que activar nada.',
    raffleRulesTitle: 'Reglas del sorteo de la semana',
    raffleRulesTicketsTitle: 'Consigue tickets',
    raffleRulesTicketsBodyPrefix: 'Completa las misiones del día: dan tickets',
    raffleRulesTicketsBodySuffix: 'del sorteo.',
    raffleRulesChanceTitle: 'Invierte y aumenta tu probabilidad',
    raffleRulesChanceBody:
      'Invierte tickets en la ronda: cuantos más pongas, mayor es tu probabilidad. Lo invertido no se devuelve, pero siempre puedes añadir más.',
    raffleRulesFinalTitle: 'La final',
    raffleRulesFinalBody:
      'La ronda dura una semana. El ganador se elige al azar y el skin llega directo al inventario.',
    racePrizeLabel: 'Premio del día',
    raceYourPlace: 'Tu puesto',
    raceParticipantsLabel: 'Participan',
    raceNotWagered: 'Juega hoy a cualquier juego y entras en la carrera',
    raffleTitle: 'Sorteo de la semana',
    raffleEmpty: 'Esta semana no hay sorteo',
    raffleMyInvestedLabel: 'Invertido',
    raffleParticipantsLabel: 'Participan',
    raffleParticipantOne: 'participante',
    raffleParticipantFew: 'participantes',
    raffleParticipantMany: 'participantes',
    raffleInvestButton: 'Invertir',
    raffleGoToQuestsButton: 'A las misiones',
    raffleEndedButton: 'Ronda finalizada',
    raffleWinnersLink: 'Ganadores',
    investSheetTitle: 'Invertir en el sorteo',
    investSheetLockedBody: 'Únete a SHOT BAND para invertir en el sorteo semanal.',
    investSheetJoinButton: 'Unirse',
    investSheetEndedBody: 'Esta ronda ya terminó: espera la siguiente.',
    investSheetNoBalanceBody: 'Aún no tienes nada que invertir: completa las misiones del día para conseguir.',
    investSheetDecrease: 'Reducir',
    investSheetIncrease: 'Aumentar',
    investSheetBalanceHint: 'Disponible: {{balance}}',
    investSheetDisclaimer: 'Lo invertido no se devuelve: puedes añadir más en cualquier momento.',
    investSheetErrorGeneric: 'No se pudo invertir. Inténtalo de nuevo.',
    investSheetSubmitButton: 'Invertir',
  },
  pl: {
    title: 'SHOT BAND',
    loading: 'Wczytywanie SHOT BAND...',
    heroWelcome: 'Witaj w',
    heroMemberBadge: 'Jesteś w SHOT BAND',
    heroDaysLeftOne: 'Został {{count}} dzień',
    heroDaysLeftFew: 'Zostały {{count}} dni',
    heroDaysLeftMany: 'Zostało {{count}} dni',
    heroDaysLeftZero: 'Członkostwo kończy się dziś',
    heroRenewButton: 'Przedłuż',
    heroOfferTitlePrefix: 'Doładowanie konta na',
    heroOfferTitleSuffix: 'włącza klub — tutaj albo przy zwykłym doładowaniu konta.',
    heroOfferBody: 'Cashback do 4% — rośnie z poziomem, codzienne zadania i szansa na nóż w losowaniu.',
    heroOfferFinePrint:
      'Cała kwota trafi na twoje saldo gry. Wydasz ją na skrzynki, kontrakty, gry i upgrade’y, jak chcesz.',
    heroJoinButton: 'Dołącz za',
    heroHowItWorks: 'Jak to działa',
    rulesTitle: 'Jak działa SHOT BAND',
    rule1Prefix: 'Wpłać ',
    rule1Suffix: ' jedną płatnością — i jesteś w SHOT BAND na 28 dni. Monety trafią na twoje saldo jak zwykle.',
    rule1Title: 'Wejście do SHOT BAND',
    rule2Title: 'Cashback do 4%',
    rule2:
      'Każda gra za monety zwraca cashback w iskrach. Procent rośnie z poziomem — 1% na 10., 4% na 100. Odbieraj co 7 dni.',
    rule3Title: 'Skrzynki za iskry',
    rule3Prefix: 'Iskry ',
    rule3Suffix: ' otwierają skrzynki SHOT BAND — w środku skiny aż po noże.',
    rule4Title: 'Zadania i seria',
    rule4Prefix: 'Codzienne zadania dają ',
    rule4Mid: '. Utrzymaj serię 7 dni — dostaniesz +10 ',
    rule4Suffix: ' w bonusie.',
    rule5Title: 'Losowanie noża',
    rule5Prefix: 'Co tydzień losujemy nóż. Wrzucaj ',
    rule5Suffix: ' — im więcej losów, tym większa szansa.',
    rule6Title: 'Wyścig dnia',
    rule6:
      'Zagraj za monety więcej niż inni do północy czasu moskiewskiego — a skin dnia jest twój. Codziennie nowa nagroda.',
    rule7Title: 'Darmowe skrzynki za obrót',
    rule7:
      'Dzienny obrót otwiera skrzynki z półki za darmo — im więcej grasz, tym cenniejsza darmowa skrzynka. Nawet wszystkie skrzynki, codziennie.',
    ticketSheetTitleJoin: 'Dołączenie do SHOT BAND',
    ticketSheetTitleRenew: 'Przedłużenie SHOT BAND',
    ticketSheetTopupNotePrefix: 'Na saldo od razu trafi',
    ticketSheetTopupNoteSuffix: '— klub dostajesz w prezencie.',
    ticketSheetRenewDisclaimer: 'Przedłużenie doda się do bieżącego okresu członkostwa — plus 28 dni.',
    ticketSheetRenewTooEarly: 'Przedłużenie otworzy się dobę przed końcem członkostwa — zajrzyj bliżej tego terminu.',
    ticketSheetBuyButton: 'Zapłać',
    ticketSheetLoadingProviders: 'Wczytujemy metody płatności...',
    ticketSheetNoProviders: 'Obecnie brak dostępnych metod płatności.',
    ticketSheetErrorTitle: 'Nie udało się utworzyć rachunku',
    ticketSheetErrorHint: 'Spróbuj jeszcze raz albo wybierz inną metodę',
    ticketSheetLoadErrorGeneric: 'Nie udało się wczytać metod płatności.',
    ticketSheetPriceUnavailable: 'Cena niedostępna dla tej metody — wybierz inną.',
    ticketSheetCardConfirmTitle: 'Potwierdź płatność',
    ticketSheetCardConfirmMessage: 'Pobrać {{amount}} z karty {{card}} za dołączenie do SHOT BAND?',
    ticketSheetCardConfirmOk: 'Zapłać',
    ticketSheetCardPending: 'Click jeszcze potwierdza płatność — członkostwo włączy się automatycznie.',
    ticketSheetCardErrorTitle: 'Płatność nie przeszła',
    ticketSheetCardErrorHint: 'Spróbuj jeszcze raz; jeśli pieniądze zeszły z karty, napisz do wsparcia',
    cashbackBalanceLabel: 'Saldo klubu',
    cashbackCoinsLabel: 'Iskry',
    cashbackTicketsLabel: 'Losy',
    cashbackNextPayoutLabel: 'Następna wypłata:',
    mechanicNameCase: 'Skrzynki',
    mechanicNameBattle: 'Case Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Ruletka',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Kontrakty',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback od {{level}} poziomu',
    cashbackSpendButton: 'Wydaj',
    cashbackInvestButton: 'Wrzuć',
    cashbackFrozenNote:
      'Członkostwo się skończyło — iskry i losy zostają twoje. Iskry możesz odebrać nadal, ale wydawać je i wrzucać losy da się tylko w klubie.',
    cashbackUnlockButton: 'Wróć',
    cashbackClaimReadyLabel: 'Cashback gotowy:',
    cashbackClaimButton: 'Odbierz',
    cashbackTimerLabel: 'za',
    streakDayLabel: 'Dzień {{day}} z 7',
    streakHint: '{{days}} dni z rzędu — bonus',
    freeCasesTitle: 'Darmowa skrzynka',
    freeCasesTurnoverLabel: 'Obrót dzisiaj',
    freeCasesNextHintPrefix: 'Jeszcze',
    freeCasesNextHintSuffix: 'obrotu — i otworzysz ją za darmo',
    freeCasesReadyHint: 'Można otworzyć za darmo — bierz!',
    freeCasesAllClaimed: 'Wszystkie darmowe otwarcia na dziś wykorzystane — nowe po resecie',
    freeCasesTimerBurnOpen: 'Jeśli nie otworzysz do resetu — przepadnie',
    freeCasesTimerBurnProgress: 'Postęp obrotu przepadnie za',
    freeCasesTimerPlain: 'Do resetu dnia',
    freeCasesTimerNew: 'Nowe darmowe otwarcia za',
    freeCasesOpenFreeButton: 'Otwórz',
    freeCasesRulesTitle: 'Zasady darmowej skrzynki',
    freeCasesRulesWagerTitle: 'Graj za monety',
    freeCasesRulesWagerBody:
      'Każda gra za monety wlicza się do dziennego obrotu — skrzynki, battle, upgrade’y, kontrakty, Rush Mid, ruletka.',
    freeCasesRulesOpenTitle: 'Próg osiągnięty — otwierasz za darmo',
    freeCasesRulesOpenBody:
      'Każda skrzynka ma własny próg obrotu. Doszedłeś do niego — klub płaci za otwarcie. Jedno darmowe otwarcie skrzynki dziennie.',
    freeCasesRulesResetTitle: 'O północy wszystko przepada',
    freeCasesRulesResetBody:
      'O północy czasu moskiewskiego dzień się zeruje: postęp obrotu i niewykorzystane darmowe otwarcia przepadają. Nowy dzień — od zera.',
    questsTitle: 'Zadania dnia',
    questsResetLabel: 'Nowe zadania za',
    questClaimButton: 'Odbierz',
    questsLockedJoinButton: 'Dołącz',
    questGenericTitle: 'Codzienne zadanie',
    questCompletedToastOverline: 'Zadanie wykonane!',
    questGenericUnit: '',
    quest_open_3_cases_2500_prefix: 'Otwórz 3 skrzynki od',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'skrzynki',
    quest_rush_3_matches_prefix: 'Zagraj 3 mecze w Rush Mid',
    quest_rush_3_matches_unit: 'mecze',
    quest_open_band_case_prefix: 'Otwórz skrzynkę SHOT BAND',
    quest_open_band_case_unit: 'skrzynka',
    quest_wager_25k_prefix: 'Zagraj za',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Zagraj 2 battle z wejściem od',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'battle',
    quest_upgrades_3_2500_prefix: 'Zrób 3 upgrade’y od',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'upgrade’y',
    quest_contract_10k_prefix: 'Złóż kontrakt od',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'kontrakt',
    quest_win_battle_prefix: 'Wygraj battle',
    quest_win_battle_unit: 'battle',
    quest_win_upgrade_prefix: 'Wygraj upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Otwórz skrzynkę od',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'skrzynka',
    quest_open_5_cases_1000_prefix: 'Otwórz 5 skrzynek od',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'skrzynek',
    quest_roulette_play_prefix: 'Zagraj rundę ruletki',
    quest_roulette_play_unit: 'runda',
    quest_contracts_25k_sum_prefix: 'Złóż kontrakty na kwotę',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Zrób upgrade’y na kwotę',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Zagraj 5 meczów Rush Mid',
    quest_rush_5_matches_unit: 'meczów',
    quest_wager_50k_prefix: 'Zagraj za',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Zagraj za',
    quest_wager_10k_battles_suffix: 'w battle',
    quest_wager_10k_rush_prefix: 'Zagraj za',
    quest_wager_10k_rush_suffix: 'w Rush Mid',
    quest_wager_10k_roulette_prefix: 'Zagraj za',
    quest_wager_10k_roulette_suffix: 'w ruletce',
    quest_wager_100k_prefix: 'Zagraj za',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Wygraj w Rush Mid',
    quest_rush_mid_win_unit: 'wygrana',
    quest_big_drop_25k_prefix: 'Wydropuj przedmiot wart ponad',
    quest_big_drop_25k_suffix: 'ze skrzynki',
    quest_big_drop_25k_unit: 'przedmiot',
    quest_risky_upgrade_35_prefix: 'Wygraj upgrade z szansą do 35%',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Wydropuj przedmiot Covert ze skrzynki',
    quest_covert_drop_unit: 'przedmiot',
    raceTitle: 'Wyścig dnia',
    raceEmpty: 'Dziś nie ma wyścigu — zajrzyj później',
    rulesLinkLabel: 'Zasady',
    raceRulesTitle: 'Zasady wyścigu dnia',
    raceRulesPlayTitle: 'Jak wygrać',
    raceRulesPlayBody:
      'Graj w SHOT w co chcesz — skrzynki, upgrade’y, kontrakty, battle, Rush Mid, ruletka. Liczą się monety wydane na gry: wygrywa ten, kto ma największy obrót w ciągu dnia.',
    raceRulesPrizeTitle: 'Nagroda',
    raceRulesPrizeBody:
      'Codziennie nowy skin. O północy czasu moskiewskiego trafia do pierwszego miejsca i od razu ląduje w ekwipunku.',
    raceRulesMembersTitle: 'Tylko dla klubu',
    raceRulesMembersBody:
      'Wyścig jest dla członków SHOT BAND. Twoja gra liczy się automatycznie — nic nie trzeba włączać.',
    raffleRulesTitle: 'Zasady losowania tygodnia',
    raffleRulesTicketsTitle: 'Zdobywaj losy',
    raffleRulesTicketsBodyPrefix: 'Wykonuj zadania dnia — dają za nie losy',
    raffleRulesTicketsBodySuffix: 'do losowania.',
    raffleRulesChanceTitle: 'Wrzucaj i zwiększaj szansę',
    raffleRulesChanceBody:
      'Wrzucaj losy do rundy — im więcej, tym większa szansa. Wrzucone losy nie wracają, ale dorzucać możesz zawsze.',
    raffleRulesFinalTitle: 'Finał',
    raffleRulesFinalBody: 'Runda trwa tydzień. Zwycięzcę wyłania los, a skin od razu ląduje w ekwipunku.',
    racePrizeLabel: 'Nagroda dnia',
    raceYourPlace: 'Twoje miejsce',
    raceParticipantsLabel: 'Uczestniczy',
    raceNotWagered: 'Zagraj dziś w dowolną grę — i jesteś w wyścigu',
    raffleTitle: 'Losowanie tygodnia',
    raffleEmpty: 'W tym tygodniu nie ma losowania',
    raffleMyInvestedLabel: 'Wrzucono',
    raffleParticipantsLabel: 'Uczestniczy',
    raffleParticipantOne: 'uczestnik',
    raffleParticipantFew: 'uczestników',
    raffleParticipantMany: 'uczestników',
    raffleInvestButton: 'Wrzuć',
    raffleGoToQuestsButton: 'Do zadań',
    raffleEndedButton: 'Runda zakończona',
    raffleWinnersLink: 'Zwycięzcy',
    investSheetTitle: 'Wrzuć do losowania',
    investSheetLockedBody: 'Dołącz do SHOT BAND, aby wrzucać do cotygodniowego losowania.',
    investSheetJoinButton: 'Dołącz',
    investSheetEndedBody: 'Ta runda już się zakończyła — poczekaj na następną.',
    investSheetNoBalanceBody: 'Na razie nie masz co wrzucać — wykonuj zadania dnia, żeby zdobyć losy.',
    investSheetDecrease: 'Zmniejsz',
    investSheetIncrease: 'Zwiększ',
    investSheetBalanceHint: 'Dostępne: {{balance}}',
    investSheetDisclaimer: 'Wrzucone losy nie wracają — dorzucić możesz w każdej chwili.',
    investSheetErrorGeneric: 'Nie udało się wrzucić. Spróbuj jeszcze raz.',
    investSheetSubmitButton: 'Wrzuć',
  },
});
